// Thunks extracted from NavigationModule.js

import _ from "lodash";
import client from "lib/apolloClient/client";
import ACLStorage from "lib/aclService";
import { goBack, go, getCurrentPathname } from "services/NavigationService";
import { SNPv2_MANAGE_EVALUATION_CYCLES_PERMISSION } from "Constants/permissionConstants";
import {
  updateCurrentScreen,
  fetchInvitedUserByToken,
  fetchInvitedParentByToken,
  verifyClassInviteLinkAndNavigateToCreateParent,
  authenticateUserWithServer,
  logoutUser,
  setRetentionModalStatus,
  switchChild,
  setProductUpdateDirectLinkOpen,
  setHelpCenterVideoDirectLinkOpen,
  updateInvitedFamilyData,
  familyInviteTokenSignIn,
  handleAcademicYearForParent,
  setAuthRegion,
  setCurrentPageTitle,
  getUserInfo,
  getOrgWorkSpaceDetails,
  isPublicSchoolLoginPage,
  isPublicAppDownloadRoute,
  isPublicMobileUnsupportedRoute,
  setToastMsg,
  verifySentralOauthRedirectUrl,
  updateChildId,
  callSamlGenerateApi,
  getLoginConfig,
  parsePipsState,
  signInUsingCode,
} from "Login/modules/LoginModule";
import { MODULES, hasModuleAdminAccess } from "lib/staffPermissionUtils";
import { updateIsNotificationProcessed } from "Teacher/routes/StudentGoals/modules/StudentGoalsModules";
import { getChildrenQuery } from "modules/CommonQuery";
import { getChildrenFromCache } from "modules/CommonGraphqlHelpers";
import {
  getAdminParentNodeMemoize,
  getAdminNode,
} from "Administrator/modules/AdministratorModule";
import { setCurrentCurriculumProgram } from "Platform/modules/PlatformModule";
import {
  getCanAccessProfileV2,
  getFamilyCanAccessStudentProfile,
} from "Platform/routes/ProfileV2/modules/Utils";
import ACLStore from "lib/aclStore";
import {
  isTouchableV2,
  isTouchableV3,
  getQueryString,
  getBackendServerUrl,
  isUserTypeParent,
  downloadButtonRedirectionForFamilyApp,
  isUserTypeStaff,
} from "Utils";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
  ROLE_VISITOR,
  LEX_PILOT_CODE_VERIFIER_KEY,
  LEX_CODE_VERIFIER_KEY,
  PROJECT_DEADLINE_REMINDER,
  IS_TODDLE_INITIATED,
  ESF_SENTRAL_LOGIN,
  COMPLETED,
  THIS_WEEK,
} from "Constants/stringConstants";
import { LEX_SSO_URL, LEX_PILOT_SSO_URL } from "Constants";
import { getUserAcadYearConstantsMemoize } from "Login/components/ChildrenPage/Utils";
import {
  getJsonItem,
  setJsonItem,
  clearLocalStorageForKey,
  setSamlInitiatedDetails,
} from "services/localStorage";
import { syncModuleRoutes } from "SyncV2/routes/SyncSetup/modules/Utils";
import {
  isIEAssessment,
  getProjectGroupTypeFromId,
} from "Projects/modules/ProjectModules";
import {
  ATTENDANCE_CONSTANTS,
  ROUTE_CONSTANTS,
} from "Constants/attendanceConstants";
import {
  getSelectedCurriculumId,
  getUserCurriculumPrograms,
  getCurrentCurriculumProgramType,
  getOrganizationCurriculumPrograms,
  getIsAccountOrSchoolPortal,
} from "../CommonSelectors";
import {
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_DP_TOK,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT,
  PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
} from "Teacher/routes/Projects/Constants/stringConstants";
import { getIsProjectGroupTypeCASOrSL } from "Projects/modules/Utils";
import i18next from "i18next";
import { navigateToIncident } from "Incident/modules/IncidentModule";
import axios from "lib/axiosInstance";
import {
  generateCodeChallenge,
  generateRandomString,
  decodeFromBase64,
} from "Utils/StringHelpers";
import moment from "moment";
import { setSelectedCourseId } from "Teacher/routes/PortfolioReview/modules/PortfolioReviewModule";
import {
  isPortfolioReviewSetupEnabled,
  getIsEnableFamilyConsolidatedPortfolio,
} from "Post/utils";
import { enableOrgWorkspaceLoginFlow, getIsChina } from "config";
import { getIsCoreOrSubjectGroupType } from "Projects/config/constants";
import { findModuleByJobType } from "Integrations/modules/IntegrationsUtils";
import { INTEGRATIONS_MODULE_ROUTE_MAP } from "Integrations/modules/IntegrationsConstants";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { getSelectedLearningCourseId } from "LearningCourse/modules/Utils";
import { updateNavigationObject } from "./NavigationActions";
import {
  campaignParams,
  getQueryUpdatedQueryString,
  handlePipsMobileRedirection,
  handleSamlMobileRedirection,
  handleBlackbaudMobileRedirection,
  handleAppRedirection,
  handleStudentGoalsAppRedirection,
  handlePostMobileRedirection,
  getIsSaaRevampEnabled,
  getIsCombineCurriculumHomePageEnabled,
  handleSentralMobileRedirection,
} from "./NavigationUtils";
import { isSinglePageAndNewUnitView } from "UnitPlans/modules/UnitViewModeUtils";
import {
  goToRelativeRoute,
  openLinkInNewTab,
} from "modules/Services/ServicesThunks";
import {
  ROUTE_TYPES,
  TEACHER_PROFILE_NAV_CONTEXT,
} from "./NavigationConstants";
import {
  isSentralPortalFeatureEnabled,
  getIsNewAdminUIEnabled,
  getIsCoursePlanRouteEnabled,
  getIsChinaTemplate,
  checkIsUnitPlanViewRevampEnabledInLibrary,
} from "Utils/ACLStoreUtils";
import {
  SENTRAL_PERMISSION_CONFIGURATIONS,
  storeStudentNavigationForSentral,
} from "Login/components/SentralPortalModal/SentralPortalUtils";
import { isToddleLibraryRouteBySegment as isToddleLibraryRoute } from "Utils/RouteMatchUtils";

// Thunk Helpers
const redirectHof = ({
  cb,
  route,
  url,
  academicYearId,
  studentId,
  orgId,
  ...rem
}) => {
  if (academicYearId) {
    route += _.includes(route, "?")
      ? `&academicYearId=${academicYearId}`
      : `?academicYearId=${academicYearId}`;

    url += _.includes(url, "?")
      ? `&academicYearId=${academicYearId}`
      : `?academicYearId=${academicYearId}`;
  }
  if (studentId) {
    route += _.includes(route, "?")
      ? `&studentId=${studentId}`
      : `?studentId=${studentId}`;
  }

  if (orgId) {
    route += _.includes(route, "?") ? `&orgId=${orgId}` : `?orgId=${orgId}`;
  }
  return cb({ ...rem, url, route, academicYearId, studentId });
};

const openLinkInNewTabHof = ({ ...rem }) => {
  return redirectHof({ cb: openLinkInNewTab, ...rem });
};

export const goToRelativeRouteHof = ({
  route,
  type,
  academicYearId,
  studentId,
  queryParamsToPreserve = [],
  ...rem
}) => {
  return redirectHof({
    cb: goToRelativeRoute,
    ...rem,
    route,
    type,
    academicYearId,
    studentId,
    queryParamsToPreserve: [
      ...queryParamsToPreserve,
      "academicYearId",
      "studentId",
      "orgId",
    ],
  });
};

// Thunks
export const getCurrentTab = () => {
  return (dispatch, getState) => {
    const currentTabArray = getCurrentPathname().split("/");
    return currentTabArray[currentTabArray.length - 1];
  };
};

export const handleQueryParameters = ({ query = {} } = {}) => {
  return (dispatch, getState) => {
    campaignParams({ query });
    // pips returns id_token as URL fragment instead of the query params
    // hence query will be empty, and in that case check for `pips` in url to continue
    if (
      _.isEmpty(query) &&
      !_.includes(window.location.href, "pips") &&
      !_.includes(window.location.href, "sso/sentral")
    ) {
      return;
    }
    const { metadata } = query;

    let metadataObj = {};
    try {
      metadataObj = metadata ? JSON.parse(metadata) : {};
    } catch (e) {
      metadataObj = {};
    }

    const params = { ...query };

    if (!_.isEmpty(metadataObj)) {
      params["metadata"] = metadataObj;
    }

    dispatch(
      navigate({
        params,
        navigateType: "replace",
      })
    );
  };
};

/**
 * @deprecated: This function isn't used anymore.
 * To Handle old /home routes and replace it with curriculum program type
 */

export const updateQueryParameters = ({
  params,
  navigateType = "push",
  paramsToBeRemoved,
}) => {
  return (dispatch, getState) => {
    const queryString = getQueryUpdatedQueryString({
      url: _.get(window, "location.search", ""),
      params,
      paramsToBeRemoved,
    });

    dispatch(
      goToRelativeRouteHof({
        route: `?${queryString}`,
        type: navigateType,
      })
    );
  };
};

const goToSnpChat = ({ metadata, dispatch }) => {
  const chatType = _.get(metadata, "item", "");
  const reviewStageId = _.get(metadata, "review_stage_id", "");
  const categoryGroupId = _.get(metadata, "category_group_id", "");
  const conversationParentId = _.get(metadata, "conversationParentId", "");

  const cycleId = _.get(metadata, "cycleId", "");

  const conversationId = _.get(metadata, "conversationId", "");

  const { studentId, academicYearId, orgId } = metadata || {};

  /**
   * When the navigate function is called via email redirection, it will receive canManageEvaluationCycle from metadata.
   * This is done because ACLStorage is not ready to be used when we compute url due to its dependency on graphql queries.
   * which is initialized in ChildrenPage component.
   *
   * So, for email redirection canManageEvaluationCycle is passed in metadata, whereas for in app navigation, canManageEvaluationCycle is computed from ACLStorage.
   */
  const canManageEvaluationCycle =
    _.get(metadata, "canManageEvaluationCycle", false) ||
    ACLStorage.getPermissionValue(SNPv2_MANAGE_EVALUATION_CYCLES_PERMISSION);

  const curriculumProgramId = _.get(metadata, "curriculum_program_id", "");

  dispatch(
    updateNavigationObject({
      snpChatDetails: {
        conversationId,
        reviewStageId,
        categoryGroupId,
        parentType: chatType,
        conversationParentId,
      },
    })
  );

  const adminSchoolDocumentsRoute = `snp_v2/cycles/${cycleId}/view/school-documents`;
  const evidenceDashboardRoute = `snp_v2/cycles/${cycleId}/view/evidence-dashboard`;
  const visitorEvidenceDashboardRoute = `platform/visitors/cycles/${cycleId}/view/evidence-dashboard`;
  const visitorSchoolDocumentsRoute = `platform/visitors/cycles/${cycleId}/view/school-documents`;

  switch (chatType) {
    case "SNP_STANDARD_SCHOOL_INTERNAL": {
      dispatch(
        goToPlatformHomeChildRoute({
          route: evidenceDashboardRoute,
          curriculumProgramId,
          studentId,
          academicYearId,
          orgId,
        })
      );

      break;
    }
    case "SNP_DOCUMENT_SCHOOL_VISITING": {
      if (canManageEvaluationCycle) {
        dispatch(
          goToPlatformHomeChildRoute({
            route: adminSchoolDocumentsRoute,
            curriculumProgramId,
            orgId,
          })
        );
      } else {
        dispatch(goToRoute({ route: visitorSchoolDocumentsRoute }));
      }
      break;
    }
    case "SNP_STANDARD_SCHOOL_VISITING": {
      if (canManageEvaluationCycle) {
        dispatch(
          goToPlatformHomeChildRoute({
            route: evidenceDashboardRoute,
            curriculumProgramId,
            orgId,
          })
        );
      } else {
        dispatch(goToRoute({ route: visitorEvidenceDashboardRoute }));
      }
      break;
    }
    case "SNP_DOCUMENT_VISITING_INTERNAL": {
      dispatch(goToRoute({ route: visitorSchoolDocumentsRoute }));
      break;
    }
    case "SNP_STANDARD_VISITING_INTERNAL": {
      dispatch(goToRoute({ route: visitorEvidenceDashboardRoute }));
    }
  }
};

const _goToSnpCycle = ({ metadata, dispatch }) => {
  const { cycleId, curriculumProgramId, studentId, academicYearId, orgId } =
    metadata || {};
  const teacherPortalUrl = `snp_v2/cycles/${cycleId}/view`;

  return dispatch(
    goToPlatformHomeChildRoute({
      route: teacherPortalUrl,
      curriculumProgramId,
      studentId,
      academicYearId,
      orgId,
    })
  );
};

const emailRedirection = ({
  dispatch,
  userType,
  isUserLoggedin,
  mailUserType,
  curriculumProgramId,
  userEmail,
}) => {
  if (isUserLoggedin && userType !== mailUserType) {
    dispatch(
      goToPlatformHomeChildRoute({
        route: ``,
        curriculumProgramId,
      })
    );

    setTimeout(() => {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:you_are_logged_in_with_different_role",
          locale_params: [
            { key: "user_email", value: userEmail, isPlainText: true },
            { key: "user_role", value: userType, isPlainText: true },
          ],
          type: "warning",
          position: "toast-bottom-left",
          timeout: 5000,
          isClosable: true,
        })
      );
    }, 3000); // this timeout is added so that the login view component could mount and load the need full locales resources
    return true;
  }
  if (!isUserLoggedin) {
    // Public mobile-redirect routes — stop further processing in
    // handleQueryParameters so navigate() / handleAppRedirection() never fires.
    if (isPublicAppDownloadRoute() || isPublicMobileUnsupportedRoute()) {
      return true;
    }
    const loginType = {
      staff: "teacherLogin",
      student: "studentLogin",
      parent: "parentLogin",
    };
    // redirect to login screen with redirect url= target url
    window.location.href = `/?redirect_url=${encodeURIComponent(
      window.location.href
    )}&type=${loginType[mailUserType]}&usertype=${mailUserType}`;
    return true;
  }
  return false;
};

export const navigateToWorkflow = ({ workflowId, isOpenInNewTab = false }) => {
  return async dispatch => {
    const route = `/platform/workflow/${workflowId}`;
    if (isOpenInNewTab) {
      dispatch(openLinkInNewTab({ url: route }));
    } else {
      dispatch(
        goToRelativeRoute({
          route,
          type: "push",
        })
      );
    }
  };
};

export const navigate = ({
  params,
  navigateType = "push",
  callback,
  target,
  appendCurriculumIdInQueryParam,
} = {}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    let type = _.toUpper(_.get(params, "type", ""));
    let schoolRoute;
    let isNewAdminUIEnabled;
    let metadata = _.get(
      params,
      "metadata",
      _.get(params, "locationContext", {}) // locationContext is base64encoded {type,metadata}
    );
    const messageData = _.get(params, "messageData", {});
    const combinedEntities = _.get(messageData, "entities", []);

    const userType = _.get(params, "usertype", "staff");
    const userTypeParams = _.get(params, "userType", "staff");

    const source = _.get(params, "source", "");
    const userLoggedIn = getState().login.userLoggedIn;

    // for FamilyPortal notification's take userType from redux
    const isParent = userInfo.user_type === "parent";

    // for student classroom revamp take userType from redux
    const isStudent = userInfo.user_type === "student";

    //get code from redirect uri -- clever will return code
    const code = _.get(params, "code", "");
    const tokenId = _.get(params, "TokenID", "");
    const scope = _.get(params, "scope");
    const ssoParams = _.get(params, "sso");
    const myschoolOrg = _.get(params, "school", "");
    const blackbaudSSOToken = _.get(params, "ssotoken", "");
    const blackbaudSchool = _.get(params, "school", "");
    const isStudentWorkbookForceViewMode = _.get(
      params,
      "isStudentWorkbookForceViewMode",
      false
    );

    const getRedirectionSource = () => {
      switch (target) {
        case "notification":
          return "NOTIFICATION";
        case "studentProfile":
          return "STUDENT_PROFILE";
        default:
          return "";
      }
    };

    // for pips
    // pips will return id_token as URL fragment instead of query param
    // Extract the fragment from the URL and parse the fragment to get the id_token and state
    const hash = window.location.hash;
    const urlSearchParams = new URLSearchParams(hash.substring(1));
    const pipsIdToken = urlSearchParams.get("id_token");
    const pipsState = urlSearchParams.get("state");

    const redirectUri = _.get(params, "redirect_url", {});
    if (code && _.includes(scope, "district_admins")) {
      type = "CLEVER_LOGIN";
    }

    if (
      code &&
      _.includes(scope, "openid") &&
      !_.includes(scope, "googleapis")
    ) {
      type = "LEX_LOGIN";
    }

    if (
      code &&
      _.includes(scope, "openid") &&
      !_.includes(scope, "googleapis") &&
      _.get(params, "source") === "pilot-lex"
    ) {
      type = "LEX_PILOT_LOGIN";
    }

    if (_.get(params, "source", null) === "pilot-lex" && !code) {
      const codeVerifier = generateRandomString(96);
      setJsonItem({ key: LEX_PILOT_CODE_VERIFIER_KEY, value: codeVerifier });
      const codeChallenge = generateCodeChallenge(codeVerifier);
      window.location.href = LEX_PILOT_SSO_URL(codeChallenge);

      return;
    }

    if (_.get(params, "source", null) === "lex") {
      const codeVerifier = generateRandomString(96);
      setJsonItem({ key: LEX_CODE_VERIFIER_KEY, value: codeVerifier });
      const codeChallenge = generateCodeChallenge(codeVerifier);
      window.location.href = LEX_SSO_URL(codeChallenge);
    }

    if (code && _.get(params, "source", false)) {
      if (params.source.includes("IRMAK_SCHOOL")) {
        type = "IRMAK_LOGIN";
      }
    }

    if (code && _.includes(window.location.href, "classlink")) {
      type = "CLASSLINK_LOGIN";
    }

    if (code && _.includes(window.location.href, "veracross-nist")) {
      type = "VERACROSS_LOGIN";
      schoolRoute = "nist";
    }
    if (code && _.includes(window.location.href, "veracross-isp")) {
      type = "VERACROSS_LOGIN";
      schoolRoute = "isp";
    }
    if (code && _.includes(window.location.href, "veracross-dssh")) {
      type = "VERACROSS_LOGIN";
      schoolRoute = "dssh";
    }
    if (code && _.includes(window.location.href, "veracross-dwight")) {
      type = "VERACROSS_LOGIN";
      schoolRoute = "dwight";
    }
    if (code && _.includes(window.location.href, "veracross-nishimachi")) {
      type = "VERACROSS_LOGIN";
      schoolRoute = "nishimachi";
    }
    if (code && !schoolRoute && _.includes(window.location.href, "veracross")) {
      type = "VERACROSS_COMMON_LOGIN";
      schoolRoute = myschoolOrg;
    }
    if (tokenId && _.includes(window.location.href, "shriconnect")) {
      type = "SHRICONNECT_LOGIN";
    }
    if (code && _.includes(window.location.href, "vedanya")) {
      type = "VEDANYA_LOGIN";
    }
    if (code && _.includes(window.location.href, "rpgis")) {
      type = "RPGIS_LOGIN";
    }
    if (code && _.includes(window.location.href, "prometheus")) {
      type = "PROMETHEUS_LOGIN";
    }
    if (code && _.includes(window.location.href, "kulish")) {
      type = "KULISH_LOGIN";
    }
    if (code && _.includes(window.location.href, "saml")) {
      type = "SAML";
    }
    if (_.includes(window.location.href, "oauth/v2/authorize")) {
      type = "OAUTH_LOGIN";
    }
    if (pipsIdToken && _.includes(window.location.href, "pips")) {
      type = "PIPS";
    }
    if (
      myschoolOrg &&
      ssoParams &&
      _.includes(window.location.href, "myschool")
    ) {
      type = "MYSCHOOL_LOGIN";
    }

    if (
      blackbaudSSOToken &&
      blackbaudSchool &&
      _.includes(window.location.href, "blackbaud")
    ) {
      type = "BLACKBAUD";
    }

    if (
      _.includes(window.location.href, "sso/sentral") &&
      !_.includes(window.location.href, "sentral-verify")
    ) {
      type = ESF_SENTRAL_LOGIN;
    }

    if (_.includes(window.location.href, "sso/spinit")) {
      // SAML IdP flow initiated by external Service Provider.
      // External service provider redirects user to this Toddle endpoint,
      // Toddle (acting as IdP) processes the request and generates
      // SAML response to authenticate user back to the requesting SP.
      type = "SAML_EXTERNAL_SP_REQUEST";
    }

    // if type is INVITE_FAMILY and locationContext is empty then it means user is using an old invite link,
    // so redirect user to home and show toast message to use new invite link
    if (
      type === "INVITE_FAMILY" &&
      _.isEmpty(_.get(params, "locationContext", {}))
    ) {
      dispatch(goToRelativeRoute({ path: "/" }));
      setTimeout(() => {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:invalid_invite_link",
            type: "warning",
          })
        );
      }, 3000); // this timeout is added so that the login view component could mount and load the need full locales resources
      return;
    }

    // if redirection source is email and query params have locationContext then decode metadata
    if (source === "email" && _.get(params, "locationContext", false)) {
      const decodedData = JSON.parse(decodeFromBase64(metadata));
      metadata = JSON.parse(_.get(decodedData, "metadata", "{}"));
      type = _.toUpper(_.get(decodedData, "type", ""));
      isNewAdminUIEnabled = _.get(metadata, "isNewAdminUIEnabled", false);

      delete params.locationContext;
      params.metadata = metadata;
    }

    const {
      authenticatedRoute = false,
      studentId,
      taskId,
      parentId,
      circularId,
      assignmentId,
      studentAssignmentId,
      assessmentId,
      conversationType,
      unitPlanId,
      chatId,
      conversationId,
      reportTaskGroupId,
      entityId,
      entityType,
      itemId,
      item_id,
      projectGroupId,
      projectId,
      course_id,
      parentResourceId,
      parentResourceType,
      sprId,
      courseId,
      portfolioId,
      curriculumType,
      curriculumProgramId,
      teacherId,
      projectGroupSubType = "",
      isUnitLibraryRoute = false,
      projectGroupType = "",
      status,
      academicYearId,
      incidentId,
      orgId,
      jobType,
      subTaskId,
      eventId,
      startDateTime,
      circularCreatedIn = "",
      isConsolidatedPortfolioEnabled = true,
      isCombinedCurriculumHome = false,
    } = metadata || {};
    const isEmailSource = source === "email";
    const metadataUserType = _.get(
      metadata,
      "jwtUser.userType",
      _.get(metadata, "userType", "")
    );
    const userId = _.get(userInfo, "id", "");
    const loggedInUserEntityType = _.get(userInfo, "userEntityType", "");
    const loggedInUserType = _.get(userInfo, "user_type", "");
    const isMobileDevice = isTouchableV3();
    // When the user explicitly chose "Continue on mobile browser" we must not
    // try to open the native app again (it would loop back to the store).
    // Computed here (above emailRedirection) so the gate below can also use it.
    const skipMobileRedirect =
      new URLSearchParams(window.location.search).get("skipMobileRedirect") ===
      "true";
    if (
      source === "email" &&
      !_.isEmpty(metadataUserType) &&
      (!isMobileDevice || skipMobileRedirect)
    ) {
      // Skip email redirection for INVITE_FAMILY type
      // Family invite emails now include source=email in the URL params along with locationContext
      // This was causing issues with the email invite flow since INVITE_FAMILY should handle
      // its own authentication and redirect logic via the invite token and inviteCode
      // Continue with normal navigation flow to process the family invitation
      if (type !== "INVITE_FAMILY" && type !== "INVITE_FAMILY_V3") {
        const endExecution = emailRedirection({
          dispatch,
          userType: loggedInUserType,
          mailUserType: metadataUserType,
          isUserLoggedin: userLoggedIn,
          curriculumProgramId,
          userEmail: userInfo?.email,
        });
        if (endExecution) return;
      }
    }

    const isUserTypeParent =
      _.get(metadata, "userType") === "parent" || isParent;
    if (curriculumProgramId && curriculumType) {
      dispatch(
        setCurrentCurriculumProgram({
          id: curriculumProgramId,
          type: curriculumType,
        })
      );
    }

    const mobileDevice = isTouchableV2();
    // On public mobile-redirect routes the user should stay on the page —
    // skip all deeplink / handleAppRedirection logic entirely.
    if (isPublicAppDownloadRoute() || isPublicMobileUnsupportedRoute()) {
      return;
    }
    const queryString = getQueryString(params);
    if ((!authenticatedRoute || !!userInfo.id) && type) {
      switch (type) {
        case "COLLABORATOR":
          dispatch(
            goToUnitPlanDetail({
              ...metadata,
              unitPlanId: metadata.unitPlanId,
              courseId: metadata.courseId,
              navigateType,
              isUnitLibraryRoute,
              academicYearId,
              curriculumProgramId,
              orgId,
            })
          );
          break;

        case "NOTIFICATION_PREFERENCES":
          {
            const redirectionHandler = async route => {
              const userInfo = getUserInfo();
              const userId = userInfo.id;
              const queryVariables = {
                id: userId,
                type: "FAMILY_MEMBER",
              };

              const childrenFromCache = getChildrenFromCache(queryVariables);

              let childrenData = childrenFromCache;

              if (_.isEmpty(childrenFromCache)) {
                const childrenFromQuery = await client.query({
                  query: getChildrenQuery,
                  variables: queryVariables,
                  fetchPolicy: "network-only",
                });
                childrenData = _.get(childrenFromQuery, "data.node", {});
              }

              const allChildren = _.get(childrenData, "children", []);

              const childData = !studentId
                ? _.first(allChildren)
                : _.find(allChildren, { id: studentId });

              if (_.isEmpty(childData)) {
                dispatch(
                  goToPlatformHomeChildRoute({
                    route: route,
                  })
                );
                return;
              }

              // switch child
              dispatch(switchChild({ childData }));

              const allCourses = _.get(childData, "allCourses");
              let orgAcademicYears = _.cloneDeep(
                _.get(childData, "organization.academicYears", {})
              );

              //if academicYearId is passed then give preference to that year
              let isCurrentAcademicYearSelected = false;
              if (academicYearId) {
                _.forEach(orgAcademicYears, year => {
                  if (year?.id === academicYearId) {
                    isCurrentAcademicYearSelected = true;
                    year.isCurrentAcademicYear = true;
                  } else {
                    year.isCurrentAcademicYear = false;
                  }
                });
              }

              // if not find the academicYearId in the given set then switch back to initial state
              if (!isCurrentAcademicYearSelected) {
                orgAcademicYears = _.cloneDeep(
                  _.get(childData, "organization.academicYears", {})
                );
              }

              const organizationCurriculumPrograms = _.get(
                childData,
                "organization.curriculumPrograms",
                []
              );

              const { currentAcadYearObj } = getUserAcadYearConstantsMemoize({
                allCourses,
                orgAcademicYears,
                organizationCurriculumPrograms,
              });

              const academicYearCurriculumProgram = !_.isEmpty(
                currentAcadYearObj?.curriculumPrograms
              )
                ? currentAcadYearObj?.curriculumPrograms
                : childData?.curriculumPrograms;

              const academicYearCurriculumProgramId = _.get(
                academicYearCurriculumProgram,
                "[0].id"
              );

              const routePath = `/platform/${
                academicYearCurriculumProgramId || curriculumProgramId
              }/${route}`;
              dispatch(
                goToRelativeRouteHof({
                  route: routePath,
                  academicYearId,
                  studentId,
                  state: getState(),
                  queryParamsToPreserve: ["moduleKey", "settingKey"],
                })
              );

              dispatch(handleAcademicYearForParent());
            };
            const moduleKey = _.get(metadata, "moduleKey");
            const settingKey = _.get(metadata, "settingKey");
            if (isParent) {
              redirectionHandler(
                `notification-preferences?moduleKey=${moduleKey}&settingKey=${settingKey}`
              );
            } else {
              dispatch(
                goToRelativeRoute({
                  route: `platform/${curriculumProgramId}/notification-preferences?moduleKey=${moduleKey}&settingKey=${settingKey}`,
                  type: navigateType,
                  queryParamsToPreserve: ["settingKey", "moduleKey"],
                })
              );
            }
          }
          break;
        case "TEACHER_POST_APPROVAL":
          dispatch(setSelectedCourseId(courseId));
          dispatch(
            goToPlatformHomeChildRoute({
              route: "portfolio-review",
              orgId,
            })
          );
          break;
        case "UNIT_PLAN_SHARED":
        case "UNIT_PLAN":
          // handling cross curriculum navigation occurred by global search
          if (_.get(metadata, "curriculum")) {
            dispatch(
              setCurriculumProgramInRedux(_.get(metadata, "curriculum"))
            );
          }
          dispatch(
            goToUnitPlanDetail({
              ...metadata,
              unitPlanId: metadata.unitPlanId,
              courseId: metadata.courseId,
              navigateType,
              mode: "view",
              type,
              studentId,
              curriculumProgramId,
              academicYearId,
              orgId,
            })
          );
          break;

        case "NAVIGATE_TO_UNIT_PLAN":
          dispatch(
            goToPlatformHomeFeatureRoute({ ...metadata, route: "unitPlans" })
          );
          break;

        case "LEARNING_COURSE":
          dispatch(
            goToLearningCourseChildRoute({
              learningCourseId: _.get(metadata, "learningCourseId"),
              curriculumProgramId: _.get(metadata, "curriculum"),
              route: "",
            })
          );
          break;
        case "IB_PYP":
        case "IB_MYP":
        case "UBD":
        case "IB_DP":
        case "COURSE":
        case "HOME_SCHOOL_LIBRARY_MODULE":
        case "HOME_ANNOUNCEMENT_MODULE":
        case "HOME_PROGRESS_REPORTS_MODULE_UBD":
        case "HOME_PROGRESS_REPORTS_MODULE_MYP":
        case "HOME_PROGRESS_REPORTS_MODULE_DP":
        case "HOME_BEHAVIOUR_MANAGEMENT_MODULE":
        case "HOME_SCHOOL_POLICIES_AND_RESOURCES_MODULE":
        case "HOME_ATTENDANCE_MODULE":
        case "HOME_HOMEROOM_MODULE":
        case "HOME_CLASSROOM_MODULE":
        case "HOME_CALENDAR_MODULE":
        case "HOME_MESSAGING_MODULE":
        case "HOME_FAMILY_MESSAGING_MODULE":
        case "HOME_STUDENT_GOALS_MODULE":
        case "ADMIN_PANEL_MODULE":
        case "ADMIN_INTEGRATIONS_MODULE":
        case "ADMIN_ACADEMY_ANALYTICS_MODULE":
        case "ADMIN_SCHOOL_SETUP_MODULE":
        case "ADMIN_STAFF_ACCESS_PERMISSION_MODULE":
        case "ADMIN_ACADEMIC_SETUP_MODULE_PYP":
        case "ADMIN_ACADEMIC_SETUP_MODULE_MYP":
        case "ADMIN_ACADEMIC_SETUP_MODULE_UBD":
        case "ADMIN_ACADEMIC_SETUP_MODULE_DP":
        case "ADMIN_TIMETABLE_MODULE":
        case "ADMIN_PLANNING_INSIGHTS_MODULE":
        case "ADMIN_PLANNING_INSIGHTS_MODULE_DP":
        case "HOME_PLANNING_INSIGHTS_MODULE":
        case "HOME_PLANNING_INSIGHTS_MODULE_DP":
        case "ADMIN_IBIS_REGISTRATION_MODULE":
        case "ADMIN_IB_E_COURSEWORK_MODULE":
        case "ADMIN_GRADEBOOK_MODULE":
        case "HOME_GRADEBOOK_MODULE":
        case "ADMIN_BIN_MODULE":
        case "ADMIN_ANNOUNCEMENT_MODULE":
        case "ADMIN_MESSAGING_MODULE":
        case "ADMIN_BEHAVIOUR_MANAGEMENT_MODULE":
        case "ADMIN_BEHAVIOUR_CONFIGURATION_MODULE":
        case "ADMIN_ATTENDANCE_MODULE":
        case "ADMIN_UNIT_PLANNING_MODULE":
        case "ADMIN_REPORT_MODULE_PYP":
        case "ADMIN_REPORT_MODULE_MYP":
        case "ADMIN_REPORT_MODULE_UBD":
        case "ADMIN_REPORT_MODULE_DP":
        case "ADMIN_EDUCATION_CENTER_MODULE":
        case "ADMIN_SCHOOL_POLICIES_AND_RESOURCES_MODULE":
        case "ADMIN_SETTINGS_MODULE":
        case "ADMIN_AUTH_EVALUATION":
        case "HOME_AUTH_EVALUATION":
        case "WEEKLY_SCHEDULE_MODULE":
        case "PLANNING_INSIGHTS_MODULE":
        case "CLASSROOM_MODULE":
        case "JOURNAL_MODULE":
        case "CONTINUUM_MODULE_MYP":
        case "CONTINUUM_MODULE_PYP":
        case "CONTINUUM_MODULE_UBD":
        case "CLASS_SETTINGS_V2":
        case "CALENDAR_MODULE":
        case "ATTENDANCE_MODULE":
        case "TEACHER_RESOURCES_MODULE":
        case "UNIT_LIBRARY_MODULE":
        case "LE_LIBRARY_MODULE":
        case "STUDENT_PROFILE_MODULE":
        case "ASSES_LEARNING_MODULE":
        case "TEACHER_POLICIES_MODULE":
        case "TEACHER_NOTIFICATION_PREFERENCES_MODULE":
        case "MANAGE_FAMILY_MODULE":
        case "ATL_MODULE":
        case "CONCEPT_INSIGHT_MODULE":
        case "THEME_DESCRIPTOR_MODULE":
        case "LPA_INSIGHT_MODULE":
        case "SUBJECT_INSIGHT_MODULE":
        case "CLASS_SETTINGS_MODULE":
        case "POI_MODULE":
        case "SUBJECT_GROUP_OVERVIEW_MYP_INSIGHTS_MODULE":
        case "POI_MYP_INSIGHTS_MODULE":
        case "GLOBAL_CONTEXTS_MYP_INSIGHTS_MODULE":
        case "KEY_AND_RELATED_CONCEPTS_MYP_INSIGHTS_MODULE":
        case "ATL_MYP_INSIGHTS_MODULE":
        case "OBJECTIVES_MYP_INSIGHTS_MODULE":
        case "SUBJECT_STANDARDS_MYP_INSIGHTS_MODULE":
        case "LPA_MYP_INSIGHTS_MODULE":
        case "SUBJECT_GROUP_TIMELINE_MYP_INSIGHTS_MODULE":
        case "UNITS_TIMELINE_VIEW_UBD_INSIGHTS_MODULE":
        case "SKILLS_UBD_INSIGHTS_MODULE":
        case "SYLLABUS_CONTENT_DP_INSIGHTS_MODULE":
        case "SYLLABUS_OUTLINE_DP_INSIGHTS_MODULE":
        case "AIMS_DP_INSIGHTS_MODULE":
        case "ASSESSMENT_OBJECTIVES_DP_INSIGHTS_MODULE":
        case "CONNECTIONS_DP_INSIGHTS_MODULE":
        case "SUBJECT_STANDARDS_DP_INSIGHTS_MODULE":
        case "LPA_DP_INSIGHTS_MODULE":
        case "BENCHMARKS_DP_INSIGHTS_MODULE":
          dispatch(
            switchBetweenModules({ metadata, appendCurriculumIdInQueryParam })
          );
          break;

        case "REPORT_MODULE": {
          const { curriculum } = metadata;
          if (curriculum) {
            dispatch(setCurriculumProgramInRedux(curriculum));
          }

          dispatch(navigateToProgressReportRoute({ metadata }));
          break;
        }
        case "ADMIN_TRANSCRIPTS_MODULE":
          dispatch(
            switchBetweenModules({
              metadata,
              shouldIncludeCurriculumIdInEndpoint: false,
            })
          );
          break;

        case PROJECT_GROUP_TYPE_DP_CAS:
        case PROJECT_GROUP_TYPE_DP_TOK_ESSAY:
        case PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION:
        case PROJECT_GROUP_TYPE_DP_EE:
        case PROJECT_GROUP_TYPE_PERSONAL:
        case PROJECT_GROUP_TYPE_COMMUNITY:
        case PROJECT_GROUP_TYPE_SERVICE_AS_ACTON:
        case PROJECT_GROUP_TYPE_DP_G4_PROJECT:
        case PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT:
        case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT:
        case PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING: {
          const destinationCurriculumId = _.get(
            params,
            "metadata.curriculumProgramId",
            ""
          );
          const projectGroupType = _.get(params, "type");

          const routePath = `/platform/${destinationCurriculumId}/project-group-types/${projectGroupType}`;

          dispatch(
            goToRelativeRouteHof({
              route: routePath,
              navigateType: "push",
            })
          );
          break;
        }

        case "LEARNING_ENGAGEMENT":
          dispatch(
            goToResourceDetails({
              ...metadata,
              id: metadata.leId,
              type: "le",
              unitPlanId: metadata.unitPlanId,
              courseId: metadata.courseId,
              navigateType,
              studentId,
              academicYearId,
              orgId,
            })
          );
          break;

        case "LE":
        case "ASSESSMENT":
          // handling cross curriculum navigation occurred by global search
          if (_.get(metadata, "curriculum")) {
            dispatch(
              setCurriculumProgramInRedux(_.get(metadata, "curriculum"))
            );
          }
          dispatch(
            goToResourceDetails({
              ...metadata,
              id: metadata.assessmentId,
              type: "assessment",
              unitPlanId: metadata.unitPlanId,
              courseId: metadata.courseId,
              navigateType,
              studentId,
              academicYearId,
              orgId,
            })
          );
          break;

        case "COMMENT":
        case "COMMENT_POST":
        case "COMMENT_ASSESSMENT":
        case "COMMENT_UNIT_PLAN":
        case "COMMENT_ROUTINE_POST":
          dispatch(
            openComment({
              metadata,
              navigateType,
              isParent,
              isUnitLibraryRoute,
            })
          );
          break;

        case "SIGNUP":
          if (_.isEmpty(metadata)) {
            dispatch(
              updateCurrentScreen({
                type: "organizationSelection",
                navigateType: "replace",
              })
            );
          } else {
            dispatch(goToInviteSignUp({ metadata }));
          }
          break;

        case "INVITE_FAMILY_V3":
          if (mobileDevice && !skipMobileRedirect) {
            handleAppRedirection({
              deepLink: encodeURI(
                `toddle-family://login/?type=invite_family_v3&${queryString}`
              ),
              appName: "FAMILY_MEMBER",
              useApkDownloadLink: getIsChinaTemplate(),
            });
          } else {
            if (userLoggedIn) {
              await logoutUser({ redirectUri: window.location.href });
            }
            dispatch(setAuthRegion(_.get(params, "region", null)));
            dispatch(
              updateInvitedFamilyData({
                ...params,
                isV3FlowEnabled: true,
              })
            );
            const token = _.get(metadata, "token", "");
            if (!_.isEmpty(token)) {
              dispatch(
                fetchInvitedParentByToken({
                  token,
                  isV3FlowEnabled: true,
                })
              );
            } else {
              dispatch(
                updateCurrentScreen({
                  type: "loginHome",
                  paramsToBeRemoved: ["locationContext", "source", "region"],
                })
              );
            }
          }
          break;

        case "INVITE_FAMILY":
          if (mobileDevice && !skipMobileRedirect) {
            // Handle family invitation deep link for mobile devices.
            // Previously, family email invite links always used a static 'type=invite_family' parameter in the URL.
            // This has now been updated. To ensure backward compatibility, we handle both cases:
            //
            // 1. If 'type=invite_family' already exists in the queryString, use it as-is.
            // 2. If it is missing, prepend 'type=invite_family' to prevent routing conflicts.
            // 3. Avoid duplicate 'type' parameters that could break the invitation flow.
            const hasTypeInvite = /type=invite_family/.test(queryString);
            const sanitizedQueryString = hasTypeInvite
              ? queryString
              : `type=invite_family&${queryString}`;
            handleAppRedirection({
              deepLink: encodeURI(
                `toddle-family://login/?${sanitizedQueryString}`
              ),
              appName: "FAMILY_MEMBER",
              useApkDownloadLink: getIsChinaTemplate(),
            });
          } else {
            //if user already logged in as teacher/student/parent --> logout user
            dispatch(
              updateInvitedFamilyData({
                ...params,
                isV3FlowEnabled: false,
              })
            );
            if (userLoggedIn) {
              await logoutUser({ redirectUri: window.location.href });
            }

            dispatch(setAuthRegion(_.get(params, "region", null)));

            if (_.isEmpty(metadata)) {
              dispatch(
                updateCurrentScreen({
                  type: "organizationSelection",
                  navigateType: "replace",
                })
              );
            } else {
              if (_.isEmpty(metadata.login_token)) {
                dispatch(
                  fetchInvitedParentByToken({
                    token: metadata.token,
                    inviteCode: metadata.inviteCode,
                    isV3FlowEnabled: false,
                  })
                );
              } else {
                // magic link sign in
                dispatch(
                  familyInviteTokenSignIn({ login_token: metadata.login_token })
                );
              }
            }
          }
          break;
        case "SESSION_REVOKE": {
          dispatch(
            goToRelativeRouteHof({
              route: "/session-revoke",
              type: "replace",
              state: { token: _.get(params, "token", "") },
            })
          );
          break;
        }
        case "DOWNLOAD_BUTTON_REDIRECTION":
          downloadButtonRedirectionForFamilyApp({
            isChinaEnv: getIsChina(),
          });
          break;
        case "FAMILY_CLASS_INVITE":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            handleAppRedirection({
              deepLink: encodeURI(`toddle-family://login/?${queryString}`),
              appName: "FAMILY_MEMBER",
              useApkDownloadLink: getIsChinaTemplate(),
            });

            return;
          }

          if (userLoggedIn && !isParent) {
            await logoutUser({ redirectUri: window.location.href });
          }

          dispatch(setAuthRegion(_.get(params, "region", null)));

          dispatch(updateInvitedFamilyData(params));
          if (!_.isEmpty(metadata.login_token)) {
            dispatch(
              familyInviteTokenSignIn({
                login_token: metadata.login_token,
                isClassInvite: true,
              })
            );
          } else if (!_.isEmpty(metadata.token)) {
            dispatch(goToParentInviteSignUp({ metadata }));
          } else {
            dispatch(
              verifyClassInviteLinkAndNavigateToCreateParent({
                link: window.location.href,
                paramsToBeRemoved: ["metadata"],
              })
            );
          }
          break;
        case "APPROVE_TEACHER":
        case "REJECT_TEACHER":
          dispatch(
            goToAbsoluteAdminChildNode({
              childId: "TEACHER_SETUP",
              academicYearId,
            })
          );
          break;

        case "SHOW_UNIT_PLAN":
          dispatch(getUnitPlanIdFromPreset({ metadata }));
          break;

        case "POST":
        case "STUDENT_POST_APPROVED":
        case "STUDENT_POST_PUBLISHED":
          if (mobileDevice && source === "email") {
            handlePostMobileRedirection({ metadata, type, isParent });
            return;
          }
          dispatch(
            updateNavigationObject({
              postDetail: {
                rightPane: "POST_DETAIL",
                rightPaneId: metadata.parentId.toString(),
                currentTab: "PUBLISHED",
                courseId: isParent ? _.get(metadata, "courseId", null) : null,
              },
            })
          );
          if (isParent) {
            const courseId =
              _.get(metadata, "courseId") || _.get(metadata, "course_id");
            const route =
              _.get(metadata, "feedType") === "ROUTINE"
                ? `courses/${courseId}/routines`
                : getIsEnableFamilyConsolidatedPortfolio() ||
                  isConsolidatedPortfolioEnabled
                ? `family-portfolio-summary`
                : `courses/${courseId}/journal`;
            dispatch(
              handleParentNotification({
                academicYearId,
                studentId,
                route,
                curriculumProgramId,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeFeatureRoute({
                ...metadata,
                route:
                  _.get(metadata, "feedType") === "ROUTINE"
                    ? "routines"
                    : "journal",
              })
            );
          }
          break;
        case "PORTFOLIO_POST_WITH_PARENT_ID":
        case "PORTFOLIO_POST_WITHOUT_PARENT_ID":
        case "PORTFOLIO_POST":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            let deepLink;
            if (parentId) {
              deepLink =
                getIsEnableFamilyConsolidatedPortfolio() ||
                isConsolidatedPortfolioEnabled
                  ? encodeURI(
                      `toddle-family://app/${studentId}/portfolio/postDetail/${parentId}/post`
                    )
                  : encodeURI(
                      `toddle-family://app/${studentId}/postDetail/${parentId}/post`
                    );
            } else {
              deepLink =
                getIsEnableFamilyConsolidatedPortfolio() ||
                isConsolidatedPortfolioEnabled
                  ? encodeURI(`toddle-family://app/${studentId}/portfolio`)
                  : encodeURI(
                      `toddle-family://app/${studentId}/course/${courseId}/journal/journalFeed`
                    );
            }
            handleAppRedirection({ deepLink });
          }
          dispatch(
            updateNavigationObject({
              postDetail: {
                rightPane: "POST_DETAIL",
                rightPaneId: metadata?.parentId?.toString(),
                currentTab: "PUBLISHED",
                courseId: isParent ? _.get(metadata, "courseId", null) : null,
              },
            })
          );
          if (_.get(metadata, "courseId") || _.get(metadata, "course_id")) {
            const courseId =
              _.get(metadata, "courseId") || _.get(metadata, "course_id");
            const route =
              (getIsEnableFamilyConsolidatedPortfolio() ||
                isConsolidatedPortfolioEnabled) &&
              isParent
                ? `family-portfolio-summary`
                : `courses/${courseId}/journal`;
            dispatch(
              handleParentNotification({
                academicYearId,
                studentId,
                route,
                curriculumProgramId,
              })
            );
          }
          break;

        case "POST_APPROVAL_WITH_COMMENT":
          metadata.parentType = "POST";
          metadata.item_id = metadata.postId;
          dispatch(openComment({ metadata, navigateType, isParent }));
          break;

        case "POST_LIKE":
          dispatch(
            updateNavigationObject({
              postDetail: {
                rightPane: "POST_DETAIL",
                rightPaneId: metadata.postId,
                currentTab: "PUBLISHED",
              },
            })
          );
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route:
                _.get(metadata, "feedType") === "ROUTINE"
                  ? "routines"
                  : "journal",
            })
          );
          break;

        case "POST_REJECT_WITH_COMMENT":
        case "POST_APPROVAL":
        case "STUDENT_POST_REJECTED":
          dispatch(
            updateNavigationObject({
              postDetail: {
                currentTab:
                  isPortfolioReviewSetupEnabled() &&
                  _.get(metadata, "creatorUserType") === "staff"
                    ? "IN_APPROVAL_STAFF"
                    : "IN_APPROVAL",
              },
            })
          );

          dispatch(
            goToPlatformHomeFeatureRoute({ ...metadata, route: "journal" })
          );
          break;

        case "FAMILY_CONNECTED":
          break;

        case "GOAL_CREATED":
        case "GOAL_COMPLETED":
        case "GOAL_COMMENT":
        case "GOAL_MILESTONE_CREATED":
        case "GOAL_MILESTONE_COMPLETED":
        case "GOAL_MILESTONE_COMMENT":
          if (mobileDevice && !skipMobileRedirect) {
            handleStudentGoalsAppRedirection({ metadata, type });
            return;
          } else dispatch(goToGoalsRoute({ metadata, type }));
          break;

        case "STUDENT_ASSESSMENT_EVALUATION": {
          const {
            assessmentEvaluationId,
            studentAssessmentEvaluationId,
          } = metadata;

          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `assessmentEvaluation/${assessmentEvaluationId}/${studentAssessmentEvaluationId}`,
            })
          );
          break;
        }

        case "PROGRESS_REPORT_EVALUTATION":
        case "PROGRESS_REPORT_RE_EVALUTATION":
          if (!_.isNil(curriculumType)) {
            const routeFnToBeCalled = _.isEqual(
              curriculumType,
              CURRICULUM_TYPE_PYP
            )
              ? goToPlatformHomeFeatureRoute({
                  ...metadata,
                  route: `progressreport${taskId ? `/${taskId}` : ``}`,
                })
              : goToPlatformHomeChildRoute({
                  route: `progress-report-sets${
                    reportTaskGroupId && taskId
                      ? `/${reportTaskGroupId}/${taskId}`
                      : ``
                  }`,
                  studentId,
                  academicYearId,
                  orgId,
                });
            dispatch(routeFnToBeCalled);
          } else
            dispatch(
              goToPlatformHomeFeatureRoute({
                ...metadata,
                route: `progressreport${taskId ? `/${taskId}` : ``}`,
              })
            );

          break;
        case "PROGRESS_REPORT_CREATION":
          if (_.isEqual(curriculumType, CURRICULUM_TYPE_PYP))
            dispatch(
              goToPlatformHomeFeatureRoute({
                ...metadata,
                route: `progressreport`,
              })
            );
          else
            dispatch(
              goToPlatformHomeChildRoute({
                curriculumProgramId,
                studentId,
                academicYearId,
                orgId,
                route: `progress-report-sets${
                  reportTaskGroupId
                    ? `/${reportTaskGroupId}`
                    : taskId
                    ? `/${taskId}`
                    : ``
                }`,
              })
            );
          break;
        case "PROGRESS_REPORT":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            const deepLink =
              metadataUserType == "student"
                ? encodeURI(`toddle-student://app/progressReports`)
                : metadataUserType == "parent"
                ? encodeURI(`toddle-family://app/${studentId}/reports`)
                : "";
            handleAppRedirection({ deepLink });
          }
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId: metadataUserType == "parent" ? studentId : null,
              route: `progress-report${sprId ? `/${sprId}` : ``}`,
              curriculumProgramId,
              orgId,
            })
          );
          break;
        case "TEACHER_RESOURCE":
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `teacherresources${parentId ? `/${parentId}` : ``}`,
            })
          );
          break;

        case "STUDENT_RESOURCE":
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `studentresources${parentId ? `/${parentId}` : ``}`,
            })
          );
          break;

        case "PARENT_RESOURCE":
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `parentresources${parentId ? `/${parentId}` : ``}`,
            })
          );
          break;
        case "TEACHER_SCHOOL_POLICY":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to teacher app
            const deepLink = encodeURI(
              `toddle-teacher://app/schoolPolicies${
                parentId ? `/${parentId}` : ""
              }`
            );
            handleAppRedirection({ deepLink });
          }
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `teacherpolicies${parentId ? `/${parentId}` : ``}`,
            })
          );
          break;
        case "PARENT_SCHOOL_POLICY":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            const deepLink = encodeURI(
              `toddle-family://app/${studentId}/schoolPolicies${
                parentId ? `/${parentId}` : ""
              }`
            );
            handleAppRedirection({ deepLink });
          }
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId,
              route: `schoolpolicies${parentId ? `/${parentId}` : ``}`,
              curriculumProgramId,
            })
          );
          break;
        case "STUDENT_SCHOOL_POLICY":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            const deepLink = encodeURI(
              `toddle-student://app/schoolPolicies${
                parentId ? `/${parentId}` : ""
              }`
            );
            handleAppRedirection({ deepLink });
          }
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `studentpolicies${parentId ? `/${parentId}` : ``}`,
            })
          );
          break;
        case "SCHOOL_POLICIES_AND_RESOURCES":
          if (mobileDevice && !skipMobileRedirect) {
            let deepLink = "";
            if (userType === "student") {
              // redirect to student app
              deepLink = encodeURI(
                `toddle-student://app/schoolPolicies${
                  parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
                }`
              );
            } else if (userType === "staff") {
              // redirect to teacher app
              deepLink = encodeURI(
                `toddle-teacher://app/schoolPolicies${
                  parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
                }`
              );
            } else {
              // redirect to family app
              deepLink = encodeURI(
                `toddle-family://app/${studentId}/schoolPolicies${
                  parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
                }`
              );
            }
            handleAppRedirection({ deepLink });
            return;
          }

          if (isParent) {
            dispatch(
              handleParentNotification({
                academicYearId,
                studentId,
                route: `educatorcenter_v2${
                  parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
                }`,
                curriculumProgramId,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeChildRoute({
                route: `educatorcenter_v2${
                  parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
                }`,
                curriculumProgramId,
                studentId,
                academicYearId,
                orgId,
              })
            );
          }
          break;
        case "SCHOOL_POLICY":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            const deepLink = encodeURI(
              `toddle-family://app/${studentId}/schoolPolicies/${parentId}`
            );
            handleAppRedirection({ deepLink });
            return;
          }
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId,
              route: `schoolpolicies${parentId ? `/${parentId}` : ``}`,
              curriculumProgramId,
            })
          );
          break;
        case "STUDENT_PROFILE":
          if (source === "GLOBAL_SEARCH") {
            // sync destination curriculumId, because global search can show results
            // spanning across multiple curriculums
            const { curriculum } = metadata;
            dispatch(setCurriculumProgramInRedux(curriculum));
            dispatch(
              setCurrentPageTitle({
                from: "home-page",
                label: `${i18next.t("teacherHomePage:student_profile")}`,
              })
            );
          }
          dispatch(
            goToStudentProfileRoute({
              studentId,
              currentCurriculumProgramId: metadata.curriculum,
              academicYearId,
              orgId,
            })
          );
          break;
        case "PENDING_FAMILY_EMAIL_INVITATION":
        case "REJECTED_FAMILY_CLASSLINK_INVITATION":
          dispatch(navigateToMyFamilyProfile());
          break;
        case "FAMILY_PROFILE":
          dispatch(
            goToFamilyProfileRoute({
              familyId: _.get(metadata, "parent.id"),
            })
          );
          break;
        case "PARENT":
        case "STUDENT_ADDED":
        case "STUDENT_ADDED_TO_PARENT":
          if (source === "GLOBAL_SEARCH") {
            // sync destination curriculumId, because global search can show results
            // spanning across multiple curriculums
            const { curriculum } = metadata;
            dispatch(setCurriculumProgramInRedux(curriculum));
          }

          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `studentPortfolio/${studentId}`,
            })
          );
          break;

        case "SEND_INVITATION":
          dispatch(updateNavigationObject({ showInvitationBox: true }));
          dispatch(
            goToPlatformHomeChildRoute({
              route: "courses",
              studentId,
              academicYearId,
              orgId,
            })
          );
          break;

        case "CIRCULAR": {
          const circularUserType = _.get(metadata, "userType", "");
          const mobileDevice = isTouchableV3();

          if (mobileDevice && !skipMobileRedirect) {
            let appLink = circularId
              ? `toddle-family://app/${studentId}/circularDetail/${circularId}`
              : `toddle-family://app/${studentId}/circularList`;

            if (_.isEqual(circularUserType, "staff")) {
              appLink = `toddle-teacher://app/circularDetail/${circularId}`;
            }

            if (_.isEqual(circularUserType, "student")) {
              appLink = `toddle-student://app/circularDetail/${circularId}`;
            }

            const deepLink = encodeURI(appLink);
            handleAppRedirection({ deepLink });
          }

          if (!isParent) {
            dispatch(
              goToPlatformHomeChildRoute({
                ...metadata,
                route: `circulars${circularId ? `/${circularId}` : ``}`,
                studentId,
                academicYearId,
                orgId,
              })
            );
            break;
          }
          // if parent
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId,
              route: `circulars${circularId ? `/${circularId}` : ``}`,
              curriculumProgramId,
            })
          );

          break;
        }

        case "MESSAGING": {
          const chatId = _.get(metadata, "chatId", "");

          const mobileDevice = isTouchableV3();

          if (mobileDevice && !skipMobileRedirect) {
            const appLink = `toddle-family://app/messaging/join-channel/${chatId}`;
            const deepLink = encodeURI(appLink);
            handleAppRedirection({ deepLink });
          }

          dispatch(
            goToMessagingLinkRoute({
              chatId,
            })
          );

          break;
        }

        case "CIRCULAR_ADDED": {
          const circularUserType = _.get(metadata, "userType", "");

          if (mobileDevice && !skipMobileRedirect) {
            let appLink = circularId
              ? `toddle-family://app/${studentId}/circularDetail/${circularId}`
              : `toddle-family://app/${studentId}/circularList`;

            if (_.isEqual(circularUserType, "staff")) {
              appLink = `toddle-teacher://app/circularDetail/${circularId}`;
            }

            if (_.isEqual(circularUserType, "student")) {
              appLink = `toddle-student://app/circularDetail/${circularId}`;
            }

            const deepLink = encodeURI(appLink);
            handleAppRedirection({ deepLink });
          }

          if (circularCreatedIn === "CLASS") {
            const {
              learningCourseIds = [],
              circularCourseData = {},
            } = metadata;
            const courseIdToNavigate =
              _.first(_.keys(circularCourseData)) || courseId;
            const learningCourseId =
              circularCourseData[courseIdToNavigate] ||
              _.first(learningCourseIds) ||
              null;

            const parentRoute = `courses/${courseIdToNavigate}/circulars/${parentId}`;
            if (isParent) {
              dispatch(
                handleParentNotification({
                  academicYearId,
                  studentId,
                  route: parentRoute,
                  curriculumProgramId,
                })
              );
              break;
            }
            dispatch(
              goToPlatformHomeFeatureRoute({
                ...metadata,
                learningCourseId,
                courseId: courseIdToNavigate,
                route: `circulars/${parentId}`,
              })
            );
            break;
          }
          if (isParent) {
            dispatch(
              handleParentNotification({
                academicYearId,
                studentId,
                route: `circulars${parentId ? `/${parentId}` : ``}`,
                curriculumProgramId,
              })
            );
            break;
          }
          dispatch(
            goToPlatformHomeChildRoute({
              ...metadata,
              route: `circulars${parentId ? `/${parentId}` : ``}`,
              studentId,
              academicYearId,
              orgId,
            })
          );
          break;
        }
        case "CIRCULAR_REVIEW": {
          dispatch(
            goToPlatformHomeChildRoute({
              ...metadata,
              route: `circulars${parentId ? `/${parentId}` : ``}`,
            })
          );
          break;
        }
        case "ASSIGNMENT_MESSAGE_SENT":
          {
            const classroomRevampRoute = `links/classroom-details/${assignmentId}/${studentAssignmentId}/?notificationType="ASSIGNMENT_MESSAGE"`;
            const {
              learningCourseIds = [],
              learningCourseId: singleLearningCourseId,
            } = metadata;
            const learningCourseId =
              _.first(learningCourseIds) || singleLearningCourseId;
            dispatch(
              updateNavigationObject({
                showPrivateMessagingTab: true,
                redirectionSource: getRedirectionSource(),
              })
            );

            if (isParent) {
              dispatch(
                handleParentNotification({
                  studentId,
                  route: `courses/${courseId}/${classroomRevampRoute}`,
                  curriculumProgramId,
                })
              );
            } else {
              dispatch(
                goToPlatformHomeFeatureRoute({
                  ...metadata,
                  route: isStudent
                    ? classroomRevampRoute
                    : `${
                        learningCourseId ? "classroom" : "links"
                      }/classroom-details/${assignmentId}/mediamanager/${studentAssignmentId}`,
                  learningCourseId,
                })
              );
            }
          }
          break;
        case "ASSIGNMENT_GROUP_MESSAGE_SENT": {
          const classroomRevampRoute = `links/classroom-details/${assignmentId}`;
          const {
            learningCourseIds = [],
            learningCourseId: singleLearningCourseId,
          } = metadata;
          const learningCourseId =
            _.first(learningCourseIds) || singleLearningCourseId;

          dispatch(
            updateNavigationObject({
              showClassDiscussionTab: true,
              redirectionSource: getRedirectionSource(),
            })
          );
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: isStudent
                ? classroomRevampRoute
                : `${
                    learningCourseId ? "classroom" : "links"
                  }/classroom-details/${assignmentId}/classdiscussion`,
              learningCourseId,
            })
          );
          break;
        }
        case "CHAT_MESSAGE_SENT":
          dispatch(
            goToPlatformHomeChildRoute({
              ...metadata,
              route: `familyconversations/${chatId}`,
            })
          );

          break;
        case "CLASS_DISCUSSION": {
          const isUserTypeStudent =
            _.get(metadata, "userType") === "student" || isStudent;
          if (mobileDevice && isUserTypeStudent) {
            // redirect to student app
            const assignmentRouteFragment = `discussion/${assignmentId}/${conversationType}`;
            const deepLink = encodeURI(
              `toddle-student://app/${assignmentRouteFragment}`
            );
            handleAppRedirection({ deepLink, appName: "STUDENT" });
          }

          const { learningCourseId } = metadata;
          const staffRoutePrefix = learningCourseId ? "classroom" : "links";

          const assignmentRouteFragment =
            assignmentId && !isStudent
              ? `${staffRoutePrefix}/classroom-details/${assignmentId}/classdiscussion`
              : assignmentId && isStudent && studentAssignmentId
              ? `links/classroom-details/${assignmentId}/${studentAssignmentId}`
              : "";

          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              courseId,
              route: assignmentRouteFragment,
              curriculumProgramId,
              academicYearId,
              studentId,
              orgId,
            })
          );
          break;
        }
        case "PRIVATE_MESSAGE": {
          // redirect to student app or family app
          const isUserTypeStudent =
            _.get(metadata, "userType") === "student" || isStudent;
          const isUserTypeParent =
            _.get(metadata, "userType") === "parent" || isParent;

          if (mobileDevice && (isUserTypeStudent || isUserTypeParent)) {
            let deepLink, appName;
            const assignmentRouteFragment = `discussion/${assignmentId}/${conversationType}`;
            if (!isUserTypeStudent) {
              deepLink = `toddle-family://app/${studentId}/${assignmentRouteFragment}`;
              appName = "FAMILY_MEMBER";
            } else {
              deepLink = `toddle-student://app/${assignmentRouteFragment}`;
              appName = "STUDENT";
            }
            handleAppRedirection({ deepLink: encodeURI(deepLink), appName });
          } else {
            // open the link on web page
            let assignmentRouteFragment = "";
            const {
              learningCourseIds = [],
              learningCourseId: singleLearningCourseId,
            } = metadata;
            const learningCourseId =
              _.first(learningCourseIds) || singleLearningCourseId;
            if (assignmentId && studentAssignmentId) {
              assignmentRouteFragment =
                isStudent || isParent
                  ? `links/classroom-details/${assignmentId}/${studentAssignmentId}/?notificationType="ASSIGNMENT_MESSAGE"`
                  : `${
                      learningCourseId ? "classroom" : "links"
                    }/classroom-details/${assignmentId}/mediamanager/${studentAssignmentId}`;
            }
            if (isParent) {
              dispatch(
                handleParentNotification({
                  studentId,
                  route: `courses/${courseId}/${assignmentRouteFragment}`,
                  curriculumProgramId,
                  academicYearId,
                })
              );
            } else {
              dispatch(
                goToPlatformHomeFeatureRoute({
                  ...metadata,
                  learningCourseId,
                  courseId,
                  route: assignmentRouteFragment,
                  curriculumProgramId,
                  orgId,
                })
              );
            }
          }

          break;
        }
        case "STUDENT_ASSIGNMENT_SUBMISSION":
        case "AI_TUTOR_FLAGGED_MESSAGE": {
          const {
            learningCourseIds = [],
            learningCourseId: singleLearningCourseId,
          } = metadata;
          const learningCourseId =
            _.first(learningCourseIds) || singleLearningCourseId;
          dispatch(
            updateNavigationObject({
              redirectionSource: getRedirectionSource(),
            })
          );
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              learningCourseId,
              route: `${
                learningCourseId ? "classroom" : "links"
              }/classroom-details/${assignmentId}/mediamanager/${studentAssignmentId}`,
            })
          );
          break;
        }
        case "STUDENT_ASSIGNMENT_SUBMISSION_FEEDBACK":
        case "ASSIGNMENT_DEADLINE_REMINDER":
        case "STUDENT_ASSIGNMENT_OVERRIDE_STATUS":
        case "STUDENT_ASSIGNMENT_OVERRIDE_RESET_STATUS":
        case "STUDENT_ASSIGNMENT_SUBMISSION_LOCK_UPDATED":
          dispatch(
            updateNavigationObject({
              redirectionSource: getRedirectionSource(),
            })
          );
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `links/classroom-details/${item_id}`,
            })
          );
          break;
        case "ALL_STUDENT_ASSIGNMENT_SUBMISSION": {
          const {
            learningCourseIds = [],
            learningCourseId: singleLearningCourseId,
          } = metadata;
          const learningCourseId =
            _.first(learningCourseIds) || singleLearningCourseId;
          dispatch(
            updateNavigationObject({
              redirectionSource: getRedirectionSource(),
            })
          );
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `${
                learningCourseId ? "classroom" : "links"
              }/classroom-details/${assignmentId}/allsubmissions`,
              learningCourseId,
            })
          );
          break;
        }
        case "STUDENT_ASSIGNMENT_SHARED":
        case "ASSIGNMENT_SHARED_WITH_STUDENT":
        case "ASSIGNMENT_CREATE":
        case "ASSIGNMENT_CLOSE_DATE_UPDATED":
        case "ASSIGNMENT_RESCHEDULED":
        case "ASSIGNMENT_DEADLINE_UPDATED": {
          const classRoomRoute =
            metadata.contentType == "ASSIGNMENT_MEETING"
              ? "classroom"
              : `links/classroom-details/${item_id}`;

          dispatch(
            updateNavigationObject({
              redirectionSource: getRedirectionSource(),
            })
          );

          if (isParent) {
            const courseId =
              _.get(metadata, "courseId") || _.get(metadata, "course_id");

            dispatch(
              handleParentNotification({
                academicYearId,
                studentId,
                route: `courses/${courseId}/${classRoomRoute}`,
                curriculumProgramId,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeFeatureRoute({
                ...metadata,
                route: classRoomRoute,
              })
            );
          }

          break;
        }
        case "ZOOM_MEETING_CREATE":
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `classroom`,
            })
          );
          break;
        case "URL_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");

          const isWorksheetWebView = _.includes(
            redirectUri,
            "isWorksheetWebView=true"
          );
          const isSafeExamBrowser = _.includes(
            redirectUri,
            "isSafeExamBrowser=true"
          );
          const isLTIMobileView = _.includes(
            redirectUri,
            "isLTIMobileView=true"
          );

          const userId = _.get(userInfo, "id");
          const urlParams = new URLSearchParams(window.location.href);
          const urlParamUserId = urlParams.get("userId");
          const childId = urlParams.get("childId");

          // set childId for parent login via url_login
          if (!_.isEmpty(childId)) {
            dispatch(updateChildId(childId));
          }

          if (
            ((isWorksheetWebView || isLTIMobileView) &&
              userLoggedIn &&
              !_.isEqual(userId, urlParamUserId)) ||
            (!_.isEqual(userId, urlParamUserId) && // for same user skipping logout for SEB
              userLoggedIn &&
              isSafeExamBrowser)
          ) {
            await logoutUser({ redirectUri: window.location.href });
          }

          if (!userLoggedIn) {
            dispatch(
              authenticateUserWithServer({
                idToken: metadata.token,
                method: "url",
                userType,
                isToddleInitiated: false,
              })
            );
          } else if (isWorksheetWebView || isSafeExamBrowser) {
            dispatch(
              goToRelativeRouteHof({
                route: `${redirectUri}&isStudentWorkbookForceViewMode=${isStudentWorkbookForceViewMode}`,
                academicYearId,
                studentId,
                orgId,
              })
            );
          } else if (isLTIMobileView) {
            dispatch(
              goToRelativeRouteHof({
                route: `${redirectUri}&isLTIMobileView=${isLTIMobileView}`,
                academicYearId,
                studentId,
                orgId,
              })
            );
          }
          break;
        }

        case "CLEVER_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          const isToddleInitiated = getJsonItem(IS_TODDLE_INITIATED) || false;
          if (isToddleInitiated) {
            clearLocalStorageForKey(IS_TODDLE_INITIATED);
          }

          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "clever",
              redirectUri: encodeURI(window.location.origin),
              isToddleInitiated,
            })
          );

          break;
        }

        case "LEX_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          const codeVerifier = getJsonItem(LEX_CODE_VERIFIER_KEY);
          const isToddleInitiated = getJsonItem(IS_TODDLE_INITIATED) || false;
          if (isToddleInitiated) {
            clearLocalStorageForKey(IS_TODDLE_INITIATED);
          }

          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }

          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "lex",
              redirectUri: encodeURI(window.location.origin),
              codeVerifier,
              isToddleInitiated,
            })
          );

          break;
        }

        case "LEX_PILOT_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          const codeVerifier = getJsonItem(LEX_PILOT_CODE_VERIFIER_KEY);
          const isToddleInitiated = getJsonItem(IS_TODDLE_INITIATED) || false;
          if (isToddleInitiated) {
            clearLocalStorageForKey(IS_TODDLE_INITIATED);
          }

          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }

          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "pilot-lex",
              codeVerifier,
              redirectUri: `${encodeURI(
                window.location.origin
              )}/?source=pilot-lex`,
              isToddleInitiated,
            })
          );

          break;
        }

        case "CLASSLINK_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }

          const isBrowserLogin = _.get(params, "isBrowserLogin", false);
          const mobileDevice = isTouchableV3();
          if (mobileDevice && !isBrowserLogin) {
            return;
          }

          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "classlink",
              userType: "staff",
              redirectUri: encodeURI(window.location.origin),
              isToddleInitiated: false,
            })
          );
          break;
        }

        case "VERACROSS_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");

          const isToddleInitiated = getJsonItem(IS_TODDLE_INITIATED) || false;
          if (isToddleInitiated) {
            clearLocalStorageForKey(IS_TODDLE_INITIATED);
          }

          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }

          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "veracross",
              userType: "staff",
              redirectUri: `${encodeURI(
                window.location.origin
              )}/sso/veracross-${schoolRoute}`,
              schoolName: schoolRoute,
              isToddleInitiated,
            })
          );
          break;
        }

        case "VERACROSS_COMMON_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          const mobileDevice = isTouchableV3();

          if (mobileDevice && !skipMobileRedirect) {
            return;
          }

          const isToddleInitiated = getJsonItem(IS_TODDLE_INITIATED) || false;
          if (isToddleInitiated) {
            clearLocalStorageForKey(IS_TODDLE_INITIATED);
          }

          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "veracross",
              redirectUri: `${encodeURI(
                window.location.origin
              )}/sso/veracross?school=${schoolRoute}`,
              schoolName: schoolRoute,
              isToddleInitiated,
            })
          );
          break;
        }

        case "SHRICONNECT_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: tokenId,
              method: "shriconnect",
              isToddleInitiated: false,
            })
          );
          break;
        }
        case "VEDANYA_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "vedanya",
              isToddleInitiated: false,
            })
          );
          break;
        }
        case "RPGIS_LOGIN": {
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "rpgis",
              isToddleInitiated: false,
            })
          );
          break;
        }
        case "PROMETHEUS_LOGIN": {
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "prometheus",
              isToddleInitiated: false,
            })
          );
          break;
        }
        case "KULISH_LOGIN": {
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: code,
              method: "kulish",
              isToddleInitiated: false,
            })
          );
          break;
        }
        case "IRMAK_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: _.get(params, "code"),
              method: "irmak",
              source: _.get(params, "source"),
              redirectUri: encodeURI(window.location.origin),
              isToddleInitiated: false,
            })
          );

          break;
        }
        case "SAML": {
          if (_.includes(userTypeParams, ",")) {
            //multiple user type found show selection screen
            if (userLoggedIn) {
              await logoutUser({
                redirectionOption: "integration_sso",
                redirectUri: encodeURI(window.location.href),
                skipSloCall: true,
              });
            }
            break;
          }

          const isMobileDevice = isTouchableV3();
          const isMobileReq = _.get(params, "isMobileReq", false);
          const isToddleInitiated = _.get(params, "isToddleInitiated", false);
          const service = _.get(params, "service", "");
          const isBrowserLogin = _.get(params, "isBrowserLogin", false);

          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
              skipSloCall: true,
            });
            return;
          }

          if (isMobileDevice && !isBrowserLogin) {
            handleSamlMobileRedirection({ queryString, userTypeParams });
            break;
          }

          dispatch(
            authenticateUserWithServer({
              encryptedMessage: code,
              method: "saml",
              userType: userTypeParams,
              isMobileReq,
              isToddleInitiated,
              service,
            })
          );
          break;
        }

        case "OAUTH_LOGIN": {
          const clientId = _.get(params, "client_id");

          if (_.isEmpty(clientId)) {
            break;
          }

          if (!userLoggedIn) {
            goToRootPath();
          }

          break;
        }

        case "PIPS": {
          try {
            const parsedPipsState = parsePipsState(pipsState);
            const pipsUserType = _.get(parsedPipsState, "usertype", "staff");
            const pipsSchool = _.get(parsedPipsState, "school");
            const isBrowserLogin = _.get(params, "isBrowserLogin", false);
            if (userLoggedIn) {
              await logoutUser({
                redirectionOption: "integration_sso",
                redirectUri: encodeURI(window.location.href),
              });
              return;
            }

            // Use isTouchableV3() for mobile detection to ensure consistency with PipsRedirect component
            if (isMobileDevice && !isBrowserLogin) {
              handlePipsMobileRedirection({
                userType: pipsUserType,
                idToken: pipsIdToken,
                school: pipsSchool,
              });
              break;
            }

            const orgWorkSpaceDetails = getOrgWorkSpaceDetails();
            if (!_.get(orgWorkSpaceDetails, "organizationId")) {
              dispatch(
                getLoginConfig({
                  schoolCode: _.toLower(pipsSchool),
                  successCallback: orgId => {
                    return dispatch(
                      authenticateUserWithServer({
                        idToken: pipsIdToken,
                        method: "pips",
                        userType: pipsUserType,
                        orgId,
                      })
                    );
                  },
                })
              );
              break;
            }

            dispatch(
              authenticateUserWithServer({
                idToken: pipsIdToken,
                method: "pips",
                userType: pipsUserType,
                orgId: _.get(orgWorkSpaceDetails, "organizationId"),
              })
            );
            break;
          } catch (err) {
            break;
          }
        }

        case "MYSCHOOL_LOGIN": {
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }
          dispatch(
            authenticateUserWithServer({
              idToken: ssoParams,
              method: "my-school",
              schoolName: myschoolOrg,
              isToddleInitiated: false,
            })
          );
          break;
        }

        case "BLACKBAUD": {
          try {
            const userLoggedIn = _.get(getState(), "login.userLoggedIn");
            const isToddleInitiated = getJsonItem(IS_TODDLE_INITIATED) || false;
            if (isToddleInitiated) {
              clearLocalStorageForKey(IS_TODDLE_INITIATED);
            }

            if (userLoggedIn) {
              await logoutUser({
                redirectionOption: "integration_sso",
                redirectUri: encodeURI(window.location.href),
              });
              return;
            }
            dispatch(
              authenticateUserWithServer({
                idToken: blackbaudSSOToken,
                schoolName: blackbaudSchool,
                method: "blackbaud",
                callbackFn: handleBlackbaudMobileRedirection,
                mobileDevice,
                isToddleInitiated,
              })
            );
            break;
          } catch (err) {
            break;
          }
        }
        case ESF_SENTRAL_LOGIN: {
          const authCodeState = _.get(params, "state", "");
          const authCodeStateParts = _.split(authCodeState, "-");
          const userType = _.get(authCodeStateParts, "[1]", "");

          if (_.includes(authCodeState, "signin")) {
            const userLoggedIn = _.get(getState(), "login.userLoggedIn");
            if (userLoggedIn) {
              await logoutUser({
                redirectionOption: "integration_sso",
                redirectUri: encodeURI(window.location.href),
              });
              return;
            }

            const redirectUri = decodeURIComponent(
              _.join(_.slice(authCodeStateParts, 2), "-")
            );

            dispatch(
              authenticateUserWithServer({
                method: "sentral",
                idToken: code,
                schoolName: "esf",
                userType,
                redirectUri,
              })
            );
          } else {
            if (mobileDevice && !skipMobileRedirect) {
              handleSentralMobileRedirection();
              break;
            }
            verifySentralOauthRedirectUrl();
          }
          break;
        }

        case "SAML_EXTERNAL_SP_REQUEST": {
          const idpIdentificationId = _.get(params, "idpIdentificationId", "");
          const relayState = _.get(params, "relayState", "");
          const requestInfo = _.get(params, "requestInfo", "");

          if (userLoggedIn) {
            await dispatch(
              callSamlGenerateApi({
                idpIdentificationId,
                relayState,
                requestInfo,
              })
            );
          } else {
            setSamlInitiatedDetails({
              relayState,
              idpIdentificationId,
              requestInfo,
              isInitiated: true,
            });
            window.location.href = "/";
          }
          break;
        }

        case "SIGNIN_CODE_LOGIN": {
          const userLoggedIn = _.get(getState(), "login.userLoggedIn");
          if (userLoggedIn) {
            await logoutUser({
              redirectionOption: "integration_sso",
              redirectUri: encodeURI(window.location.href),
            });
            return;
          }

          if (_.isEmpty(code)) {
            dispatch(
              setToastMsg({
                msg: "Sign-in code not found. Please try again.",
                notString: true,
              })
            );
            dispatch(
              goToLoginHomeScreen({
                params: { type: "studentLogin", usertype: "student" },
              })
            );
            return;
          }

          dispatch(
            signInUsingCode({ code, goToStudentLoginPageOnError: true })
          );
          break;
        }

        case "HELP_CENTER_VIDEO": {
          const videoId = _.get(params, "videoId");
          dispatch(setHelpCenterVideoDirectLinkOpen(videoId));
          break;
        }
        case "PRODUCT_UPDATES": {
          // uses productId from metadata for shared product update through email
          const productId =
            _.get(params, "productId") || _.get(metadata, "productId");
          dispatch(setProductUpdateDirectLinkOpen(productId));
          break;
        }
        case "ALL_PRODUCT_UPDATES": {
          // uses curriculumProgramId from metadata for shared product update through email
          const curriculumProgramId = _.get(metadata, "curriculumProgramId");
          dispatch(
            goToRelativeRoute({
              route: `platform/${curriculumProgramId}/product-updates`,
            })
          );
          break;
        }
        case "RETENTION_MAILER":
          dispatch(setRetentionModalStatus(true));
          break;

        case "CALENDAR_EVENT_ITEM":
        case "CALENDAR_EVENT_ITEM_RESCHEDULED": {
          if (isParent) {
            const success = await dispatch(
              handleParentNotification({
                studentId,
                route: `courses/my-calendar`,
                orgId,
                onChildUnavailable: cbDispatch => {
                  cbDispatch(
                    setToastMsg({
                      msg: "toastMsgs:student_no_longer_associated",
                      type: "warning",
                      position: "toast-bottom-left",
                      timeout: 5000,
                      isClosable: true,
                    })
                  );
                  cbDispatch(
                    goToPlatformHomeChildRoute({
                      route: ``,
                      curriculumProgramId,
                    })
                  );
                },
              })
            );
            if (!success) break;
          } else {
            dispatch(
              goToPlatformHomeChildRoute({
                route: `courses/my-calendar`,
                curriculumProgramId,
                isCombinedCurriculumHome,
              })
            );
          }
          dispatch(
            updateNavigationObject({
              calendarEventModal: { id: item_id },
              curriculumProgramId,
            })
          );
          break;
        }
        case "VIDEO_MEETING_CREATE_NOTIFICATION":
        case "VIDEO_MEETING_UPDATE_NOTIFICATION":
        case "VIDEO_MEETING_REMINDER_NOTIFICATION": {
          const calendarEventItemId =
            item_id ||
            (startDateTime ? `${eventId}=>${startDateTime}` : eventId);

          const CALENDAR_ROUTE = `courses/my-calendar`;

          const getMeetingDetailsDeepLink = () => {
            if (metadataUserType === "student") {
              return encodeURI(
                `toddle-student://app/meetingDetails/${calendarEventItemId}`
              );
            }
            if (metadataUserType === "parent") {
              return encodeURI(
                `toddle-family://app/${studentId}/meetingDetails/${calendarEventItemId}`
              );
            }
            return encodeURI(
              `toddle-teacher://app/meetingDetails/${calendarEventItemId}`
            );
          };

          const isMobileDeepLink =
            isEmailSource && mobileDevice && !skipMobileRedirect;

          if (isMobileDeepLink) {
            // Native app performs its own student-association validation.
            handleAppRedirection({ deepLink: getMeetingDetailsDeepLink() });
          } else if (isParent) {
            const success = await dispatch(
              handleParentNotification({
                ...(isEmailSource
                  ? { academicYearId, curriculumProgramId }
                  : {}),
                studentId,
                route: CALENDAR_ROUTE,
                orgId,
                onChildUnavailable: cbDispatch => {
                  cbDispatch(
                    setToastMsg({
                      msg: "toastMsgs:student_no_longer_associated",
                      type: "warning",
                      position: "toast-bottom-left",
                      timeout: 5000,
                      isClosable: true,
                    })
                  );
                  cbDispatch(
                    goToPlatformHomeChildRoute({
                      route: ``,
                      curriculumProgramId,
                    })
                  );
                },
              })
            );
            if (!success) break;
          } else {
            // email source and in-app notification share the same redirect
            dispatch(
              goToPlatformHomeChildRoute({
                route: CALENDAR_ROUTE,
                curriculumProgramId,
                isCombinedCurriculumHome,
              })
            );
          }

          dispatch(
            updateNavigationObject({
              calendarEventModal: {
                id: `CALENDAR_EVENT_ITEM=>${calendarEventItemId}`,
              },
              curriculumProgramId,
            })
          );
          break;
        }
        case "SCHOOL_CALENDAR_EVENT_REMINDER_NOTIFICATION":
        case "CALENDAR_EVENT_ITEM_REMINDER":
        case "SCHOOL_CALENDAR_EVENT_CREATE_NOTIFICATION":
        case "SCHOOL_CALENDAR_EVENT_UPDATE_NOTIFICATION": {
          const calendarEventItemId =
            item_id ||
            (startDateTime ? `${eventId}=>${startDateTime}` : eventId);
          const isMobileDeepLink =
            isEmailSource && mobileDevice && !skipMobileRedirect;

          if (isMobileDeepLink) {
            // Native app performs its own student-association validation.
            const deepLink =
              metadataUserType == "student"
                ? encodeURI(
                    `toddle-student://app/calendarEventItem/${calendarEventItemId}`
                  )
                : metadataUserType == "parent"
                ? encodeURI(
                    `toddle-family://app/${studentId}/calendarEventItem/${calendarEventItemId}`
                  )
                : encodeURI(
                    `toddle-teacher://app/calendarEventItem/${calendarEventItemId}`
                  );
            handleAppRedirection({ deepLink });
          } else if (isParent) {
            const success = await dispatch(
              handleParentNotification({
                ...(isEmailSource
                  ? { academicYearId, curriculumProgramId }
                  : {}),
                studentId,
                route: `courses/my-calendar`,
                orgId,
                onChildUnavailable: cbDispatch => {
                  cbDispatch(
                    setToastMsg({
                      msg: "toastMsgs:student_no_longer_associated",
                      type: "warning",
                      position: "toast-bottom-left",
                      timeout: 5000,
                      isClosable: true,
                    })
                  );
                  cbDispatch(
                    goToPlatformHomeChildRoute({
                      route: ``,
                      curriculumProgramId,
                    })
                  );
                },
              })
            );
            if (!success) break;
          } else {
            // email source and in-app notification share the same redirect
            dispatch(
              goToPlatformHomeChildRoute({
                route: `courses/my-calendar`,
                curriculumProgramId,
                isCombinedCurriculumHome,
              })
            );
          }
          dispatch(
            updateNavigationObject({
              calendarEventDetails: {
                id: "CALENDAR_EVENT_ITEM=>" + calendarEventItemId,
              },
              curriculumProgramId,
            })
          );
          break;
        }
        case "STUDENT_ASSIGNMENT_SUBMISSION_UNHAND":
        case "PDFTRON_COMMENT_ADDED":
          dispatch(
            updateNavigationObject({
              redirectionSource: getRedirectionSource(),
            })
          );
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `links/classroom-details/${item_id}`,
            })
          );
          break;
        case "PERSONAL_PROJECT_STATUS_UPDATE":
        case "COMMUNITY_PROJECT_STATUS_UPDATE":
        case "PERSONAL_PROJECT_INVITATION":
        case "COMMUNITY_PROJECT_INVITATION":
        case "SERVICE_AS_ACTION_INVITATION":
        case "PERSONAL_PROJECT_REPORT_STATUS_UPDATE":
        case "COMMUNITY_PROJECT_REPORT_STATUS_UPDATE":
        case "SERVICE_AS_ACTION_ACTIVITY_APPROVAL":
        case "SERVICE_AS_ACTION_IN_PROGRESS":
        case "SERVICE_AS_ACTION_IN_PROGRESS_AFTER_APPROVAL":
        case "SERVICE_AS_ACTION_REVIEW_REQUESTED":
        case "SERVICE_AS_ACTION_COMPLETED":
        case "SERVICE_AS_ACTION_PENDING_FOR_APPROVAL":
        case "PERSONAL_PROJECT_DEADLINE":
        case "COMMUNITY_PROJECT_DEADLINE":
        case "NAVIGATE_TO_PROJECT":
        case "DP_PROJECT_DEADLINE":
        case "PROJECT_APPROVED":
        case "PROJECT_MARKED_AS_COMPLETED":
        case "PROJECT_OVERALL_STATUS_CHANGED":
        case "PROJECT_SUPERVISOR_ASSIGNED":
        case "PROJECT_REPORT_STATUS_UPDATED":
        case "WEEKLY_SUMMARY_PROJECT_DETAILS":
        case "PROJECT_DEADLINE": // PROJECT_DEADLINE used in email redirection
          {
            // mobile only support the project deadline redirection
            if (mobileDevice && type === "PROJECT_DEADLINE") {
              // redirect to mobile app
              const deadlineId = _.get(metadata, "projectDeadlineId");
              const projectId = _.get(metadata, "itemId");
              const deepLink = encodeURI(
                `toddle-family://app/${studentId}/projectScreen/${deadlineId}/${projectId}`
              );
              handleAppRedirection({ deepLink });
              return;
            }
            const { learningCourseIds = [] } = metadata;
            const learningCourseId = _.first(learningCourseIds);

            if (isParent) {
              const route = `project-group-types/${projectGroupType}/projects/${projectGroupId}/progress/${itemId}`;
              dispatch(
                handleParentNotification({
                  academicYearId,
                  curriculumProgramId,
                  studentId,
                  route,
                })
              );
            } else {
              const isUserStudent =
                _.get(getUserInfo(), "user_type", "") === "student";

              const isPortfolioRoute =
                isUserStudent &&
                (getIsProjectGroupTypeCASOrSL({ projectGroupType }) ||
                  (getIsSaaRevampEnabled(getState()) &&
                    projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON) ||
                  projectGroupType === PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT);
              const route = `${
                isPortfolioRoute
                  ? `portfolios/${portfolioId}/studentPortfolio`
                  : "progress"
              }/${itemId}`;

              dispatch(
                goToPlatformHomeProjectFeatureRoute({
                  projectGroupId,
                  route,
                  projectGroupSubType,
                  courseId,
                  studentId,
                  academicYearId,
                  orgId,
                  projectGroupType,
                  curriculumProgramId,
                  learningCourseId,
                })
              );
            }
          }
          break;
        case PROJECT_DEADLINE_REMINDER:
          {
            const { learningCourseIds = [] } = metadata;
            const learningCourseId = _.first(learningCourseIds);
            dispatch(
              updateNavigationObject({
                projectCommentBox: {
                  showProjectCommentBox: true,
                  commentParentEntityType: PROJECT_DEADLINE_REMINDER,
                  itemId: _.get(metadata, "targetEntityId", null),
                },
              })
            );
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `progress/${itemId}`,
                projectGroupSubType,
                courseId,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
                learningCourseId,
              })
            );
          }
          break;
        case "PROJECT_GROUP_TASK_CREATED":
        case "PROJECT_GROUP_TASK_SUBMISSION_ENABLED":
        case "PROJECT_GROUP_DEADLINE_CLOSED_DATE_UPDATED":
        case "PROJECT_GROUP_DEADLINE_DUE_DATE_UPDATED":
        case "PROJECT_GROUP_SUBMISSION_CLOSED_AUTOMATICALLY":
        case "PROJECT_SUBMISSION_ITEM_RESPONSE_ANNOTATED":
        case "PROJECT_TASK_MARKED_COMPLETED":
        case "PROJECT_GROUP_TASK_REMINDER":
        case "PROJECT_SUBMISSION_LOCKED":
        case "PROJECT_SUBMISSION_UNLOCKED":
          {
            const { learningCourseIds = [] } = metadata;
            const learningCourseId = _.first(learningCourseIds);
            dispatch(
              updateNavigationObject({
                projectCommentBox: {
                  showProjectCommentBox: true,
                  commentParentEntityType: PROJECT_DEADLINE_REMINDER,
                  itemId: _.get(metadata, "itemId", null),
                },
              })
            );
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `progress/${projectId}`,
                projectGroupSubType,
                courseId,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
                learningCourseId,
              })
            );
          }
          break;
        case "PROJECT_SUBMISSION_TURNED_IN":
        case "PROJECT_SUBMISSION_TURNED_IN_BY_ALL":
          {
            const { learningCourseIds = [] } = metadata;
            const learningCourseId = _.first(learningCourseIds);
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `deadlines/${itemId}/allSubmissions`,
                projectGroupSubType,
                courseId,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
                learningCourseId,
              })
            );
          }
          break;
        case "PROJECT_ATTACHMENT_ANNOTATED":
          {
            const { learningCourseIds = [] } = metadata;
            const learningCourseId = _.first(learningCourseIds);
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `progress/${itemId}/report`,
                projectGroupSubType,
                courseId,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
                learningCourseId,
              })
            );
          }
          break;
        case "PROJECT_COMMENT":
        case "PROJECT_COMMENT_MENTION":
        case "PROJECT_POST_COMMENT":
        case "PORTFOLIO_COMMENT":
        case "PORTFOLIO_COMMENT_MENTION":
        case "LO_COMMENT":
          dispatch(openComment({ metadata, navigateType, isParent }));
          break;

        case "SNP_CHAT": {
          goToSnpChat({ metadata, dispatch });
          break;
        }

        case "SNP_CYCLE_CREATION": {
          _goToSnpCycle({ metadata, dispatch });
          break;
        }

        case "FILE_RESOURCE_SHARED_WITH_STUDENT":
        case "FOLDER_RESOURCE_SHARED_WITH_STUDENT":
        case "MULTIPLE_RESOURCE_SHARED_WITH_STUDENT":
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              route: `student-drive${
                parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
              }`,
            })
          );
          break;

        case "CAS_ADVISOR_ASSIGNED":
        case "CAS_ADVISEE_ASSIGNED":
        case "CAS_OVERALL_STATUS_CHANGED":
        case "CAS_PROJECT_DELETED":
        case "PORTFOLIO_ADVISOR_ASSIGNED":
        case "PORTFOLIO_ADVISEE_ASSIGNED":
        case "CAS_MARKED_AS_COMPLETE":
        case "PORTFOLIO_PROJECT_DELETED":
        case "PORTFOLIO_OVERALL_STATUS_CHANGED":
        case "PORTFOLIO_MARKED_AS_COMPLETED":
          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route: `portfolios`,
              studentId,
              academicYearId,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;

        case "WEEKLY_SUMMARY_PORTFOLIO_DASHBOARD":
          if (isParent) {
            const route = `project-group-types/${projectGroupType}/projects/${projectGroupId}/portfolios/${portfolioId}/studentPortfolio`;
            dispatch(
              handleParentNotification({
                academicYearId,
                route,
                curriculumProgramId,
                studentId,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `portfolios/${portfolioId}`,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
              })
            );
          }
          break;

        case "CAS_ADVISOR_FEEDBACK_ADDED":
        case "PORTFOLIO_ADVISOR_FEEDBACK_ADDED":
        case "WEEKLY_SUMMARY_PORTFOLIO_FEEDBACK":
          if (isParent) {
            const route = `project-group-types/${projectGroupType}/projects/${projectGroupId}/portfolios/${itemId}/feedback`;
            dispatch(
              handleParentNotification({
                academicYearId,
                curriculumProgramId,
                studentId,
                route,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `portfolios/${itemId}/feedback`,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
              })
            );
          }
          break;
        case "WEEKLY_SUMMARY_PORTFOLIO_INTERVIEW":
          if (isParent) {
            const route = `project-group-types/${projectGroupType}/projects/${projectGroupId}/portfolios/${itemId}/formalInterviews`;
            dispatch(
              handleParentNotification({
                academicYearId,
                curriculumProgramId,
                studentId,
                route,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `portfolios/${itemId}/formalInterviews`,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
              })
            );
          }
          break;
        case "CAS_LO_ACHIEVED":
        case "PORTFOLIO_LO_ACHIEVED":
          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route: `portfolios/${portfolioId}/evidences`,
              studentId,
              academicYearId,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;
        case "CAS_PROJECT_APPROVAL_REQUESTED":
        case "CAS_PROJECT_APPROVED":
        case "CAS_PROJECT_REJECTED":
        case "CAS_PROJECT_CREATED":
        case "PORTFOLIO_PROJECT_CREATED":
        case "WEEKLY_SUMMARY_PORTFOLIO_PROJECT":
          if (isParent) {
            const route = `project-group-types/${projectGroupType}/projects/${projectGroupId}/portfolios/${portfolioId}/studentPortfolio/${itemId}`;
            dispatch(
              handleParentNotification({
                academicYearId,
                route,
                curriculumProgramId,
                studentId,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupType,
                curriculumProgramId,
                projectGroupId,
                route: `portfolios/${portfolioId}/studentPortfolio/${itemId}`,
                studentId,
                academicYearId,
                orgId,
              })
            );
          }
          break;
        case "WEEKLY_SUMMARY_PROJECT_PROGRESS":
          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route: `progress`,
              studentId,
              academicYearId,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;
        case "EE_SUPERVISOR_ASSIGNED":
        case "EE_PROPOSAL_APPROVAL_REQUESTED":
        case "EE_PROPOSAL_APPROVED":
        case "EE_MARKED_AS_COMPLETE":
        case "TOK_EXHIBITION_SUPERVISOR_ASSIGNED":
        case "TOK_ESSAY_SUPERVISOR_ASSIGNED":
        case "TOK_EXHIBITION_PROPOSAL_APPROVED":
        case "TOK_ESSAY_PROPOSAL_APPROVED":
        case "TOK_EXHIBITION_MARKED_AS_COMPLETE":
        case "TOK_ESSAY_MARKED_AS_COMPLETE":
          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route: `progress/${itemId}`,
              studentId,
              academicYearId,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;

        case "WEEKLY_SUMMARY_PROJECT_DASHBOARD":
          if (isParent) {
            dispatch(
              handleParentNotification({
                academicYearId,
                curriculumProgramId,
                studentId,
                route: `project-group-types/${projectGroupType}/projects/${projectGroupId}/progress`,
              })
            );
          } else {
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                route: `progress`,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
              })
            );
          }
          break;

        case "EE_FINAL_ESSAY_SUBMITTED":
        case "TOK_ESSAY_FINAL_DRAFT_SUBMITTED":
        case "TOK_EXHIBITION_FINAL_DRAFT_SUBMITTED":
        case "PROJECT_DRAFT_REPORT_SUBMITTED":
        case "PROJECT_FINAL_REPORT_SUBMITTED":
          {
            let route = "";
            const projectCount =
              _.size(_.get(metadata, "combinedIds", [])) ||
              _.size(combinedEntities);

            const { learningCourseIds = [] } = metadata;
            const learningCourseId = _.first(learningCourseIds);

            if (projectCount > 1) {
              route = `progress`;
            } else {
              if (
                _.includes(
                  [
                    PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT,
                    PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT,
                  ],
                  projectGroupSubType
                )
              ) {
                route = `progress/${itemId}`;
              } else if (
                _.includes(
                  ["DP_G4_PROJECT", "DP_COLLABORATIVE_SCIENCES_PROJECT"],
                  projectGroupType
                )
              ) {
                route = `progress/${itemId}/presentation`;
              } else {
                route = `progress/${itemId}/report`;
              }
            }

            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                projectGroupSubType,
                courseId,
                route,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
                learningCourseId,
              })
            );
          }
          break;
        case "EE_REFLECTION_MARKED_AS_COMPLETE":
        case "TOK_ESSAY_INTERACTION_MARKED_AS_COMPLETE":
          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route: `progress/${itemId}/rppf`,
              studentId,
              academicYearId,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;

        case "ATTENDANCE_REMINDER": {
          dispatch(goToAttendanceRoute({ params }));
          break;
        }
        case ATTENDANCE_CONSTANTS.ATTENDANCE_REMINDER_TO_HOMEROOM:
        case ATTENDANCE_CONSTANTS.NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_HOMEROOM:
        case ATTENDANCE_CONSTANTS.ATTENDANCE_EXCUSAL_MESSAGE_RECEIVED_TO_HOMEROOM: {
          dispatch(goToHomeroomAttendanceRoute({ params }));
          break;
        }
        case "DP_EXAM_APPROVAL": {
          dispatch(
            goToStudentProfileIBISRegistration({
              studentId: metadata.studentId,
              curriculumProgramId,
              isProfileEnabled: metadata.isProfileEnabled,
              academicYearId,
              orgId,
            })
          );
          break;
        }

        case ATTENDANCE_CONSTANTS.NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_PARENT:
        case ATTENDANCE_CONSTANTS.NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_ADMIN:
        case ATTENDANCE_CONSTANTS.ATTENDANCE_EXCUSAL_MESSAGE_RECEIVED:
        case ATTENDANCE_CONSTANTS.ATTENDANCE_MARKED:
        case ATTENDANCE_CONSTANTS.ATTENDANCE_MARKED_ON_EXCUSAL: {
          dispatch(goToNewAttendanceExcusalRoute({ params }));
          break;
        }

        case "ATTENDANCE": {
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            const deepLink = encodeURI(
              `toddle-family://app/${studentId}/attendance`
            );
            handleAppRedirection({ deepLink });
            return;
          }
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId,
              route: `attendance-summary`,
              curriculumProgramId,
            })
          );
          break;
        }

        //no redirection needed for these notifications
        case "PROJECT_REMOVED_AS_COLLABORATOR": {
          break;
        }

        case "PROJECT_SUPERVISEE_ASSIGNED": {
          const projectCount =
            _.size(_.get(metadata, "combinedIds", [])) ||
            _.size(_.get(metadata, "combinedEntities", [])) ||
            _.size(combinedEntities);

          let route = "";
          const projectGroupType = _.get(metadata, "projectGroupType", "");

          // REMOVE: this SAA condition and replace the function getIsProjectGroupTypeCASOrSL once SAA portfolio revamp is live for all
          route =
            getIsProjectGroupTypeCASOrSL({
              projectGroupType,
            }) ||
            (getIsSaaRevampEnabled(getState()) &&
              projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON) ||
            projectGroupType === PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT
              ? `experiences`
              : `progress`;
          if (projectCount == 1) {
            route = `${route}/${itemId}`;
          }

          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route,
              studentId,
              academicYearId,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;
        }

        case "TEACHER_PROFILE":
          if (source === "GLOBAL_SEARCH") {
            // sync destination curriculumId, because global search can show results
            // spanning across multiple curriculums
            const { curriculum } = metadata;
            dispatch(setCurriculumProgramInRedux(curriculum));
          }
          dispatch(
            navigateToTeacherProfile({
              ...metadata,
              id: teacherId,
              context: TEACHER_PROFILE_NAV_CONTEXT.CURRICULUM,
            })
          );
          break;

        case "INTEGRATION_LONG_RUNNING_NOTIFICATION": {
          dispatch(
            goToSyncModule({
              params,
            })
          );
          break;
        }

        case "PROJECT_GROUP_SUPERVISOR_APPROVAL_REQUESTED": {
          const tokens = _.get(messageData, "tokens", []);
          const supervisorType = _.get(
            _.find(tokens, elem => {
              return elem.key === "supervisorType";
            }),
            "value",
            "internal"
          );

          let route = "setup/invite/supervisor";

          switch (supervisorType) {
            case "internal":
              route = "setup/invite/supervisor";
              break;
            case "external":
              route = "setup/invite/externalSupervisor";
              break;
          }

          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route,
              studentId,
              academicYearId,
              projectGroupSubType,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;
        }

        case "PROJECT_GROUP_SUPERVISOR_APPROVAL_REQUEST_REJECTED": {
          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              route: ``,
              projectGroupSubType,
              studentId,
              academicYearId,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;
        }

        case "PROJECT_ACADEMIC_HONESTY_SUBMITTED":
        case "PROJECT_ACADEMIC_HONESTY_LOCKED":
        case "PROJECT_ACADEMIC_HONESTY_UNLOCKED": {
          let route = "";

          const projectCount =
            _.size(_.get(metadata, "combinedIds", [])) ||
            _.size(combinedEntities);

          if (projectCount > 1) {
            switch (projectGroupType) {
              case PROJECT_GROUP_TYPE_DP_G4_PROJECT:
              case PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT:
                {
                  route = `progress/${itemId}/reflection`;
                }
                break;
              default:
                {
                  route = `progress`;
                }
                break;
            }
          } else {
            switch (projectGroupType) {
              case PROJECT_GROUP_TYPE_PERSONAL:
              case PROJECT_GROUP_TYPE_COMMUNITY:
                {
                  route = `progress/${itemId}/academic-honesty`;
                }
                break;
              case PROJECT_GROUP_TYPE_DP_EE:
              case PROJECT_GROUP_TYPE_DP_TOK:
              case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT:
                {
                  route = `progress/${itemId}/rppf`;
                }
                break;
              case PROJECT_GROUP_TYPE_DP_G4_PROJECT:
              case PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT:
                {
                  route = `progress/${itemId}/reflection`;
                }
                break;
            }
          }

          dispatch(
            goToPlatformHomeProjectFeatureRoute({
              projectGroupId,
              projectGroupSubType,
              courseId,
              studentId,
              academicYearId,
              route,
              orgId,
              projectGroupType,
              curriculumProgramId,
            })
          );
          break;
        }

        case "PROJECT_REVIEW_LOG_ADDED":
        case "PROJECT_REVIEW_LOG_RESOLVED":
        case "PROJECT_REVIEW_LOG_UNRESOLVED":
        case "PROJECT_REVIEW_LOG_COMMENT_ADDED":
          {
            const { user_type: userType } = userInfo;
            const { learningCourseIds = [] } = metadata;
            const learningCourseId = _.first(learningCourseIds);

            const route =
              getIsProjectGroupTypeCASOrSL({
                projectGroupType,
              }) ||
              (getIsSaaRevampEnabled(getState()) &&
                projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON) ||
              projectGroupType === PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT
                ? userType === "student"
                  ? `portfolios/${portfolioId}/studentPortfolio`
                  : "experiences"
                : "progress";

            dispatch(
              updateNavigationObject({
                projectCommentBox: {
                  showProjectCommentBox: true,
                  fieldId: metadata.parentId,
                  commentParentEntityType: "PROJECT_REVIEW_LOG",
                },
              })
            );
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId,
                projectGroupSubType,
                courseId,
                route: `${route}/${itemId}`,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
                learningCourseId,
              })
            );
          }
          break;

        case "CLASSLINK_APPROVAL_REQUEST": {
          const learningCourseId = _.get(metadata, "learningCourseId", "");
          const courseId = _.get(metadata, "courseId", "");

          const route = learningCourseId
            ? `class-settings/${courseId}/family-members`
            : "class-settings/family-members";

          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              courseId: learningCourseId ? "" : courseId,
              route,
              learningCourseId,
            })
          );
          break;
        }

        case "STUDENT_DRIVE_RESOURCE": {
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to student app
            const deepLink = encodeURI(
              `toddle-student://app/studentDrive/driveItems${
                parentResourceType == "FOLDER"
                  ? `/${parentResourceId}`
                  : `/${courseId}`
              }/${courseId}`
            );
            handleAppRedirection({ deepLink, appName: "STUDENT" });
            return;
          }
          if (!isParent) {
            dispatch(
              goToPlatformHomeFeatureRoute({
                ...metadata,
                route: `student-drive${
                  parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
                }`,
              })
            );
            break;
          }
          // if parent
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId,
              route: `courses/${courseId}/student-drive${
                parentResourceType == "FOLDER" ? `/${parentResourceId}` : ""
              }`,
              curriculumProgramId,
            })
          );
          break;
        }

        case "SCHOOL_CALENDAR":
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to family app
            const deepLink = encodeURI(
              `toddle-family://app/${studentId}/schoolCalendar`
            );
            handleAppRedirection({ deepLink });
            return;
          }
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId,
              route: `courses/my-calendar`,
              curriculumProgramId,
            })
          );
          break;
        case "CLASSTREAM":
          {
            if (mobileDevice && !skipMobileRedirect) {
              // redirect to family app
              const assignmentRouteFragment = assignmentId
                ? `discussion/${assignmentId}`
                : "todos";

              const deepLink = encodeURI(
                `toddle-family://app/${studentId}/${assignmentRouteFragment}`
              );
              handleAppRedirection({ deepLink });
            }

            const assignmentRouteFragment =
              assignmentId && studentAssignmentId
                ? `classroom-details/${assignmentId}/${studentAssignmentId}`
                : "";

            dispatch(
              handleParentNotification({
                academicYearId,
                studentId,
                route: `todos/${assignmentRouteFragment}`,
                curriculumProgramId,
              })
            );
          }
          break;

        case "DONE":
        case "TODO": {
          if (mobileDevice && !skipMobileRedirect) {
            // redirect to mobile app
            const deepLink = encodeURI(
              `toddle-family://app/${studentId}/todos`
            );
            handleAppRedirection({ deepLink });
            return;
          }

          /**
           * Constructs the route path for TODO/DONE navigation
           * Handles legacy email links with DONE type and EVALUATED status
           * by defaulting to THIS_WEEK view with COMPLETED header tab
           * For newer links, uses the provided status and optional activeHeaderTab from metadata
           *
           * @returns {string} The todos relative path with query parameters for active tabs
           */
          const getTodosRelativePath = () => {
            let route = "todos";

            // for older email links which have type DONE but status as EVALUATED
            if (status === "EVALUATED") {
              route += `?activeTab=${THIS_WEEK}&activeHeaderTab=${COMPLETED}`;
            } else {
              route += `?activeTab=${status}`;
              const { activeHeaderTab = "TODO" } = metadata || {};

              // In todos page header Done tab value is COMPLETED
              route += `&activeHeaderTab=${
                activeHeaderTab === "DONE" ? COMPLETED : activeHeaderTab
              }`;
            }
            return route;
          };

          if (isUserTypeParent) {
            dispatch(
              handleParentNotification({
                academicYearId,
                studentId,
                route: getTodosRelativePath(),
                curriculumProgramId,
                orgId,
              })
            );
            return;
          }
          dispatch(
            goToRelativeRouteHof({
              route: `platform/${curriculumProgramId}/${getTodosRelativePath()}`,
              type: navigateType,
              academicYearId,
              studentId,
              orgId,
              queryParamsToPreserve: ["activeTab"],
            })
          );
          break;
        }

        case "STUDENT_ASSIGNMENT": {
          const isUserTypeStudent =
            _.get(metadata, "userType") === "student" || isStudent;
          const isUserTypeParent =
            _.get(metadata, "userType") === "parent" || isParent;

          if (mobileDevice && (isUserTypeStudent || isUserTypeParent)) {
            // redirect to app
            let deepLink, appName;
            let assignmentRouteFragment = `discussion/${assignmentId}/${conversationType}`;

            // If email type is evaluation shared then add query params tab=RESPONSE
            // to open response tab directly in mobile app
            const isEvaluationSharedEmail =
              _.get(metadata, "emailType", null) ===
              "ASSIGNMENT_EVALUATION_SHARED_MAIL";
            if (isEvaluationSharedEmail) {
              assignmentRouteFragment = `${assignmentRouteFragment}/?tab=RESPONSE`;
            }

            if (!isUserTypeStudent) {
              deepLink = `toddle-family://app/${studentId}/${assignmentRouteFragment}`;
              appName = "FAMILY_MEMBER";
            } else {
              deepLink = `toddle-student://app/${assignmentRouteFragment}`;
              appName = "STUDENT";
            }
            handleAppRedirection({ deepLink: encodeURI(deepLink), appName });
          } else {
            const assignmentRouteFragment =
              assignmentId && studentAssignmentId
                ? `links/classroom-details/${assignmentId}/${studentAssignmentId}`
                : "";
            if (isParent) {
              dispatch(
                handleParentNotification({
                  studentId,
                  route: `courses/${courseId}/${assignmentRouteFragment}`,
                  curriculumProgramId,
                })
              );
            } else {
              dispatch(
                goToPlatformHomeFeatureRoute({
                  ...metadata,
                  courseId,
                  route: assignmentRouteFragment,
                  curriculumProgramId,
                  academicYearId,
                  studentId,
                  orgId,
                })
              );
            }
          }
          break;
        }

        case "ALL_SUBMISSIONS": {
          const { learningCourseId } = metadata;
          const routePrefix = learningCourseId ? "classroom" : "links";
          const assignmentRouteFragment = assignmentId
            ? `${routePrefix}/classroom-details/${assignmentId}/allsubmissions`
            : "";

          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              courseId,
              route: assignmentRouteFragment,
              curriculumProgramId,
              academicYearId,
              studentId,
              orgId,
            })
          );
          break;
        }

        case "STUDENT_NOTE_ADDED": {
          dispatch(
            goToStudentProfileRoute({
              studentId,
              currentCurriculumProgramId: _.first(
                _.get(metadata, "curriculumProgramIds", [])
              ),
              activeTab: "teacher_notes",
              academicYearId,
              orgId,
            })
          );
          break;
        }

        case "CLASS_MATERIALS_RESOURCE": {
          if (mobileDevice && !skipMobileRedirect) {
            let deepLink, appName;
            const isFamilyApp = !_.isEmpty(studentId);

            if (isFamilyApp) {
              deepLink = `toddle-family://app/${studentId}/course/${courseId}/classMaterials`;
              appName = "FAMILY_MEMBER";
            } else {
              deepLink = `toddle-student://app/course/${courseId}/classMaterials`;
              appName = "STUDENT";
            }

            handleAppRedirection({ deepLink: encodeURI(deepLink), appName });
          } else {
            if (isParent) {
              dispatch(
                handleParentNotification({
                  studentId,
                  route: `courses/${courseId}/class-flow`,
                  curriculumProgramId,
                  academicYearId,
                })
              );
            } else {
              dispatch(
                goToPlatformHomeFeatureRoute({
                  ...metadata,
                  route: "class-flow",
                })
              );
            }
          }
          break;
        }

        case "BEHAVIOUR_INCIDENT": {
          const userType = _.get(metadata, "userType");

          if (mobileDevice && userType) {
            const isUserTypeStaff = userType === "staff";
            const isUserTypeParent = userType === "parent";
            const isUserTypeStudent = userType === "student";

            let deepLink = "";
            let appName = "";

            const isBehaviourEnabledInTeacherMobile = ACLStore.can(
              "FeatureFlag:BehaviourTeacherMobile"
            );

            if (isUserTypeStudent) {
              // redirect to student app
              deepLink = encodeURI(
                `toddle-student://app/behaviourManagement/incident/${incidentId}`
              );
              appName = "STUDENT";
            } else if (isUserTypeStaff && isBehaviourEnabledInTeacherMobile) {
              // redirect to teacher app
              deepLink = encodeURI(
                `toddle-teacher://app/behaviourManagement/incident/${incidentId}`
              );
              appName = "STAFF";
            } else if (isUserTypeParent) {
              // redirect to family app
              deepLink = encodeURI(
                `toddle-family://app/${studentId}/behaviourManagement/incident/${incidentId}`
              );
              appName = "FAMILY_MEMBER";
            }

            if (deepLink) {
              handleAppRedirection({ deepLink, appName });
              return;
            }
          }

          if (isParent) {
            dispatch(
              handleParentNotification({
                studentId,
                route: `incident/${incidentId}`,
                state: { isSwitchChildRedirect: true },
                curriculumProgramId,
              })
            );
          } else {
            dispatch(navigateToIncident({ incidentId, curriculumProgramId }));
          }

          break;
        }
        case "BEHAVIOUR_INCIDENT_UPDATES":
        case "BEHAVIOUR_INCIDENT_ACTIONS":
        case "BEHAVIOUR_INCIDENT_ACCESSIBILITY": {
          if (isParent) {
            dispatch(
              handleParentNotification({
                studentId,
                route: `incident/${incidentId}`,
                state: { isSwitchChildRedirect: true },
              })
            );
          } else {
            dispatch(navigateToIncident({ incidentId, curriculumProgramId }));
          }

          break;
        }
        case "INTEGRATIONS_SYNC": {
          dispatch(
            goToSyncDashboard({
              jobType,
              curriculumProgramId,
              isNewAdminUIEnabled,
            })
          );
          break;
        }

        case "WORKFLOW_SUBTASK": {
          dispatch(
            navigateToWorkflow({
              workflowId: subTaskId,
            })
          );
          break;
        }

        //Should remove this default
        default: {
          const orgWorkSpaceDetails = getOrgWorkSpaceDetails();

          // go to organization workspace login-page if school code is found
          if (
            !!enableOrgWorkspaceLoginFlow &&
            !isPublicSchoolLoginPage() &&
            !_.isEmpty(_.get(orgWorkSpaceDetails, "schoolCode"))
          ) {
            navigateToOrgWorkspaceLoginPage({
              schoolcode: orgWorkSpaceDetails.schoolCode,
              userType: params.usertype,
            });
          }
          dispatch(updateCurrentScreen({ ...params }));
        }
      }
    }
    if (callback) {
      callback();
    }
  };
};

export const handleParentNotification = ({
  studentId = "",
  route = "",
  curriculumProgramId,
  academicYearId = null, // extracted from the metadata optional
  orgId = null, // extracted from the metadata optional
  state,
  // Optional override for the empty-child fallback. When provided, invoked instead
  // of the default redirect (callers handle their own toast/redirect UX).
  onChildUnavailable = null,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const childID = userInfo.childID;
    const userId = userInfo.id;
    const handleUnavailable = () => {
      if (onChildUnavailable) {
        onChildUnavailable(dispatch);
      } else {
        dispatch(goToPlatformHomeChildRoute({ route }));
      }
    };
    /** __FamilyPortal__
     *  childID: current active child Id
     *  studentId: child Id associated with notification
     */
    // Active child already matches (or no studentId): no switch needed.
    if (_.isNil(studentId) || childID == studentId) {
      dispatch(
        goToPlatformHomeChildRoute({
          route,
          curriculumProgramId,
          academicYearId,
          orgId,
        })
      );
      return true;
    }

    const queryVariables = {
      id: userId,
      type: "FAMILY_MEMBER",
    };

    const childrenFromCache = getChildrenFromCache(queryVariables);

    let childrenData = childrenFromCache;

    if (_.isEmpty(childrenFromCache)) {
      try {
        const childrenFromQuery = await client.query({
          query: getChildrenQuery,
          variables: queryVariables,
          fetchPolicy: "network-only",
        });
        childrenData = _.get(childrenFromQuery, "data.node", {});
      } catch (error) {
        handleUnavailable();
        return false;
      }
    }

    const allChildren = _.get(childrenData, "children", []);

    const childData = _.find(allChildren, {
      id: _.toString(studentId),
    });

    if (_.isEmpty(childData)) {
      handleUnavailable();
      return false;
    }

    // switch child
    dispatch(switchChild({ childData }));

    const allCourses = _.get(childData, "allCourses");
    let orgAcademicYears = _.cloneDeep(
      _.get(childData, "organization.academicYears", {})
    );

    //if academicYearId is passed then give preference to that year
    let isCurrentAcademicYearSelected = false;
    if (academicYearId) {
      _.forEach(orgAcademicYears, (year = {}) => {
        if (year.id === academicYearId) {
          isCurrentAcademicYearSelected = true;
          year.isCurrentAcademicYear = true;
        } else {
          year.isCurrentAcademicYear = false;
        }
      });
    }

    // if not find the academicYearId in the given set then switch back to initial state
    if (!isCurrentAcademicYearSelected) {
      orgAcademicYears = _.cloneDeep(
        _.get(childData, "organization.academicYears", {})
      );
    }

    const organizationCurriculumPrograms = _.get(
      childData,
      "organization.curriculumPrograms",
      []
    );

    const { currentAcadYearObj } = getUserAcadYearConstantsMemoize({
      allCourses,
      orgAcademicYears,
      organizationCurriculumPrograms,
    });

    const academicYearCurriculumProgram = !_.isEmpty(
      currentAcadYearObj?.curriculumPrograms
    )
      ? currentAcadYearObj.curriculumPrograms
      : childData?.curriculumPrograms;

    const academicYearCurriculumProgramId = _.get(
      academicYearCurriculumProgram,
      "[0].id"
    );

    const routePath = `/platform/${
      academicYearCurriculumProgramId || curriculumProgramId
    }/${route}`;

    dispatch(
      goToRelativeRouteHof({
        route: routePath,
        academicYearId,
        studentId,
        orgId,
        state,
      })
    );

    dispatch(handleAcademicYearForParent());
    return true;
  };
};

export const goToLoginHomeScreen = ({ params, isOpenInNewTab }) => {
  return async (dispatch, getState) => {
    const { type, metadata } = params || {};
    const { academicYearId, studentId, orgId } = metadata || {};
    const queryString = getQueryUpdatedQueryString({ url: "", params });
    const routePath = `/${queryString ? `?${queryString}` : ``}`;
    if (isOpenInNewTab) {
      dispatch(openLinkInNewTabHof({ url: routePath }));
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
          academicYearId,
          studentId,
          orgId,
        })
      );
      dispatch(
        updateCurrentScreen({
          type,
          navigateType: "replace",
        })
      );
    }
  };
};

export const goToHomeroomAttendanceRoute = ({ params }) => {
  return async (dispatch, getState) => {
    const {
      date,
      excusalId,
      curriculumProgramId,
      studentId,
      academicYearId,
      orgId,
      isCombinedCurriculumHome,
    } = _.get(params, "metadata", {});

    const formattedDate =
      date && moment(date).isValid() ? moment(date).format("YYYY-MM-DD") : null;

    dispatch(
      updateNavigationObject({
        attendanceDate: formattedDate,
        excusalId,
      })
    );
    const getHomeroomRedirectRoute = ({ curriculumProgramId, excusalId }) => {
      switch (true) {
        case getIsCombineCurriculumHomePageEnabled():
        case isCombinedCurriculumHome:
          return `platform/my-home/homeroom?tab=excusals&curriculumProgramId=${curriculumProgramId}`;
        case _.isNil(excusalId):
          return `platform/${curriculumProgramId}/homeroom`;
        default:
          return `platform/${curriculumProgramId}/homeroom?tab=excusals`;
      }
    };

    const routeToNavigate = getHomeroomRedirectRoute({
      curriculumProgramId,
      excusalId,
    });

    dispatch(
      goToRelativeRouteHof({
        route: routeToNavigate,
        type: "replace",
        replacePath: "platform",
        studentId,
        academicYearId,
        orgId,
      })
    );
  };
};

export const goToAttendanceRoute = ({ params }) => {
  return async (dispatch, getState) => {
    const {
      courseId,
      learningCourseId,
      curriculumProgramId,
      date,
      studentId,
      academicYearId,
      orgId,
      isCombinedCurriculumHome = false,
    } = _.get(params, "metadata", "");

    const isLearningCoursesEnabled =
      !!learningCourseId ||
      getIsLearningCoursesEnabled({
        curriculumProgramId,
      });

    const formattedDate = moment(date).isValid()
      ? moment(date).format("YYYY-MM-DD")
      : null;

    dispatch(
      updateNavigationObject({
        attendanceDate: formattedDate,
      })
    );

    const getAttendanceRedirectRoute = () => {
      switch (true) {
        case getIsCombineCurriculumHomePageEnabled():
        case isCombinedCurriculumHome:
          return `platform/my-home/learning-course/${learningCourseId}/class/${courseId}/attendance`;
        case isLearningCoursesEnabled:
          return `platform/${curriculumProgramId}/learning-course/${learningCourseId}/class/${courseId}/attendance`;
        default:
          return `platform/${curriculumProgramId}/courses/${courseId}/attendance`;
      }
    };

    const routeToNavigate = getAttendanceRedirectRoute();

    dispatch(
      goToRelativeRouteHof({
        route: routeToNavigate,
        type: "replace",
        replacePath: "platform",
        studentId,
        academicYearId,
        orgId,
      })
    );
  };
};

export const goToGoalsRoute = ({ metadata, type }) => {
  return async (dispatch, getState) => {
    const {
      curriculumProgramId,
      goalId,
      studentId: notificationStudentId,
      goalTaskId: taskId,
      goalTasks,
      goalStatus,
      academicYearId,
      studentId,
      userType,
      orgId,
    } = metadata;

    const goalTaskId = taskId || _.get(goalTasks, "0", "");
    const itemId = goalTaskId || goalId;
    const shouldOpenItem = _.includes(
      ["GOAL_COMMENT", "GOAL_MILESTONE_COMMENT"],
      type
    );
    const notificationState = {
      goalId,
      goalTaskId,
      shouldOpenItem,
      notificationStudentId,
      goalStatus,
      itemId,
    };
    await dispatch(updateIsNotificationProcessed(false));

    if (isUserTypeParent({ userType })) {
      const route = `student-profile/${studentId}/goals`;
      dispatch(
        handleParentNotification({
          academicYearId,
          studentId: notificationStudentId,
          route,
          curriculumProgramId,
          state: notificationState,
          orgId,
        })
      );
      return;
    }

    const isCombinedCurriculumHomePage = getIsCombineCurriculumHomePageEnabled();
    const route = isCombinedCurriculumHomePage
      ? `platform/my-home/goals`
      : `platform/${curriculumProgramId}/goals`;

    dispatch(
      goToRelativeRouteHof({
        route,
        type: "replace",
        replacePath: "platform",
        academicYearId,
        studentId: notificationStudentId,
        state: notificationState,
      })
    );
  };
};

export const goToStudentProfileIBISRegistration = ({
  studentId,
  curriculumProgramId,
  isProfileEnabled: isProfileEnabledFromMetadata,
  academicYearId,
  orgId,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const userType = userInfo.user_type;
    let dpCurriculumProgramId = curriculumProgramId;

    if (!dpCurriculumProgramId) {
      const userCurriculumPrograms = getUserCurriculumPrograms(state);

      const dpCurriculumProgram = _.find(
        userCurriculumPrograms,
        curriculumProgram => curriculumProgram.type === CURRICULUM_TYPE_DP
      );

      dpCurriculumProgramId = _.get(dpCurriculumProgram, "id");
    }

    let isProfileEnabled = false;
    if (_.isUndefined(isProfileEnabledFromMetadata)) {
      if (userType === "student") {
        isProfileEnabled = getCanAccessProfileV2({ userType });
      } else if (userType === "parent") {
        isProfileEnabled = getFamilyCanAccessStudentProfile({ userType });
      }
    } else {
      isProfileEnabled = isProfileEnabledFromMetadata;
    }

    if (isProfileEnabled && studentId && dpCurriculumProgramId) {
      dispatch(
        goToRelativeRouteHof({
          route: `platform/${dpCurriculumProgramId}/student-profile/${studentId}/IBISRegistration`,
          replacePath: "platform",
          studentId,
          academicYearId,
          orgId,
        })
      );
    }
  };
};

export const goToSyncModule = ({ params }) => {
  return async (dispatch, getState) => {
    const type = _.get(params, "metadata.type");
    const curriculumProgramId = _.get(params, "metadata.curriculumProgramId");
    const academicYearId = _.get(params, "metadata.academicYearId");
    const studentId = _.get(params, "metadata.studentId");
    const orgId = _.get(params, "metadata.orgId");

    let route = syncModuleRoutes.jobs;
    switch (type) {
      case "DATAMAPPING": {
        route = syncModuleRoutes.mapExistingData;
        break;
      }
      case "GRADEMAPPING": {
        route = syncModuleRoutes.gradesMapping;
        break;
      }
      case "SUBJECTMAPPING": {
        route = syncModuleRoutes.subjectMapping;
        break;
      }
      case "SISFILTERS": {
        route = syncModuleRoutes.excludeSisData;
        break;
      }
      default:
        break;
    }
    dispatch(
      goToRelativeRouteHof({
        route: `platform/administrator/schoolSetup/manage-sync/${curriculumProgramId}/${route}`,
        type: "replace",
        replacePath: "platform",
        academicYearId,
        studentId,
        orgId,
      })
    );
  };
};

export const goToSyncDashboard = params => {
  return async dispatch => {
    const { jobType, curriculumProgramId, isNewAdminUIEnabled } = params;

    const module = findModuleByJobType(jobType);

    if (!module) {
      dispatch(goToRelativeRoute({ route: "/" }));
    }

    const moduleRoute = INTEGRATIONS_MODULE_ROUTE_MAP[module];

    const isAdminNavigationRevampEnabled = getIsNewAdminUIEnabled();

    if (isAdminNavigationRevampEnabled || isNewAdminUIEnabled) {
      dispatch(
        goToRoute({
          route: `platform/accountSettings/integrations/${moduleRoute}/${curriculumProgramId}/dashboard`,
        })
      );
    } else {
      const route = `schoolSetup/${moduleRoute}/${curriculumProgramId}/dashboard`;

      dispatch(goToAdminChildRoute({ route }));
    }
  };
};

export const goToNewAttendanceExcusalRoute = ({ params }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userType = _.get(userInfo, "user_type");

    const {
      userType: emailUserType,
      excusalId,
      date,
      courseId,
      periodId,
      studentId,
      curriculumProgramId,
      academicYearId,
      orgId,
      redirectToCurriculumDashboard,
      isCombinedCurriculumHome,
    } = _.get(params, "metadata", {});

    const formattedDate = moment(date).isValid()
      ? moment(date).format("YYYY-MM-DD")
      : null;

    dispatch(
      updateNavigationObject({
        excusalId,
        attendanceDate: !excusalId ? formattedDate : null,
        courseId,
        periodId,
      })
    );

    const isUserParent = isUserTypeParent({
      userType: userType || emailUserType,
    });

    const routeToNavigate = _.isNil(excusalId)
      ? "attendance-summary"
      : "attendance-summary?tab=excusals";

    const getAttendanceRedirectRoute = ({
      isUserParent,
      curriculumProgramId,
    }) => {
      switch (true) {
        case isUserParent:
          return routeToNavigate;
        case getIsCombineCurriculumHomePageEnabled():
        case isCombinedCurriculumHome:
          return `platform/my-home/attendance-dashboard?tab=excusals&curriculumProgramId=${curriculumProgramId}`;
        case ACLStore.can("TeacherPortal:AttendanceDashboard"):
        case hasModuleAdminAccess({ moduleName: MODULES.ATTENDANCE.id }):
        case getIsNewAdminUIEnabled():
        case redirectToCurriculumDashboard:
          return `platform/${curriculumProgramId}/attendance-dashboard?tab=excusals`;
        default:
          return `platform/administrator/${curriculumProgramId}/attendance-dashboard?tab=excusals`;
      }
    };

    const route = getAttendanceRedirectRoute({
      isUserParent,
      curriculumProgramId,
    });

    if (isUserParent) {
      dispatch(
        handleParentNotification({
          academicYearId,
          studentId,
          route,
          curriculumProgramId,
        })
      );
      return;
    }

    dispatch(
      goToRelativeRouteHof({
        route,
        academicYearId,
        studentId,
        orgId,
        type: ROUTE_CONSTANTS.REPLACE,
        replacePath: ROUTE_CONSTANTS.PLATEFORM,
      })
    );
  };
};

export const getUnitPlanIdFromPreset = ({ metadata }) => {
  return async (dispatch, getState) => {
    const { presetId, academicYearId, studentId, curriculumProgramId, orgId } =
      metadata || {};
    const token = _.get(JSON.parse(localStorage.userInfo), "token", "");

    const result = await axios.post(
      getBackendServerUrl({
        token,
        path: "/auth/sample/unit/fetch",
      }),
      {
        presetId,
        token,
      }
    );

    if (result) {
      // eslint-disable-next-line no-unsafe-optional-chaining
      const { course_id, unit_plan_id } = result?.data;

      dispatch(
        goToUnitPlanDetail({
          ...metadata,
          courseId: course_id,
          unitPlanId: unit_plan_id,
          navigateType: "replace",
          mode: "view",
          academicYearId,
          studentId,
          curriculumProgramId,
          orgId,
        })
      );
    }
  };
};

export const goToInviteSignUp = ({ metadata }) => {
  return (dispatch, getState) => {
    const { token } = metadata || {};

    if (token) {
      dispatch(fetchInvitedUserByToken({ token }));
    }
  };
};

export const goToParentInviteSignUp = ({ metadata }) => {
  return (dispatch, getState) => {
    const { token, inviteCode } = metadata || {};

    if (token) {
      dispatch(fetchInvitedParentByToken({ token, inviteCode }));
    }
  };
};

export const goToUnitPlanDetail = ({
  unitPlanId,
  courseId,
  navigateType,
  mode = "edit",
  isOpenInNewTab,
  isUnitLibraryRoute = false,
  type = "",
  studentId = null,
  academicYearId = null,
  curriculumProgramId = null,
  orgId = null,
  learningCourseId,
}) => {
  return (dispatch, getState) => {
    const userType = _.get(getUserInfo(), "user_type");
    if (
      studentId &&
      isUserTypeParent({ userType }) &&
      type === "UNIT_PLAN_SHARED"
    ) {
      const route = `courses/${courseId}/unitPlans/${unitPlanId}/${mode}`;
      dispatch(
        handleParentNotification({
          academicYearId,
          studentId,
          route,
          curriculumProgramId,
        })
      );
      return;
    }

    if (isUnitLibraryRoute) {
      let featureRoute;
      if (isSinglePageAndNewUnitView()) {
        featureRoute = `school-library/units/${unitPlanId}/`;
      } else {
        featureRoute = `school-library/units/${unitPlanId}/${mode}`;
      }
      dispatch(
        goToPlatformHomeChildRoute({
          route: featureRoute,
          orgId,
          isOpenInNewTab,
        })
      );
    } else {
      const isLearningCoursesEnabled = getIsLearningCoursesEnabled();
      const isCoursePlanRouteEnabled = getIsCoursePlanRouteEnabled();

      let featureRoute;
      if (isSinglePageAndNewUnitView()) {
        if (isLearningCoursesEnabled) {
          featureRoute = isCoursePlanRouteEnabled
            ? `course-plan/${unitPlanId}/`
            : `unit/${unitPlanId}/`;
        } else {
          featureRoute = `unitPlans/${unitPlanId}/`;
        }
      } else {
        featureRoute = `unitPlans/${unitPlanId}/${mode}`;
      }
      dispatch(
        goToPlatformHomeFeatureRoute({
          courseId,
          navigateType,
          route: featureRoute,
          isOpenInNewTab,
          academicYearId,
          studentId,
          orgId,
          learningCourseId,
        })
      );
    }
  };
};

export const goToResourceDetails = ({
  id,
  unitPlanId,
  type,
  courseId,
  navigateType,
  isOpenInNewTab,
  isUnitLibraryRoute = false,
  studentId,
  academicYearId,
  orgId,
  learningCourseId,
}) => {
  return (dispatch, getState) => {
    const state = getState();
    const curriculumProgramId = getSelectedCurriculumId(state);
    const isLearningCoursesEnabled =
      !!learningCourseId ||
      getIsLearningCoursesEnabled({
        curriculumProgramId,
      });
    if (isLearningCoursesEnabled) {
      if (isOpenInNewTab) {
        const currentPath = getCurrentPathname();
        const route = `${currentPath}/${type}/${id}/view`;
        dispatch(
          openLinkInNewTabHof({ url: route, studentId, academicYearId })
        );
      } else {
        if (type === "assessment") {
          dispatch(
            goToPlatformHomeChildRoute({
              route: `school-library/units/${unitPlanId}/${type}/${id}/view`,
              navigateType,
              curriculumProgramId,
            })
          );
          return;
        }
        dispatch(goToRelativeRoute({ route: `${type}/${id}/view` }));
      }
    } else if (isUnitLibraryRoute) {
      dispatch(
        goToPlatformHomeChildRoute({
          route: `school-library/units/${unitPlanId}/${type}/${id}/view`,
          orgId,
        })
      );
    } else {
      const route = `unitPlans/${unitPlanId}/${type}/${id}/view`;

      dispatch(
        goToPlatformHomeFeatureRoute({
          courseId,
          navigateType,
          isOpenInNewTab,
          route,
          studentId,
          academicYearId,
          orgId,
          learningCourseId,
        })
      );
    }
  };
};

const setCurriculumProgramInRedux = curriculumId => {
  return (dispatch, getState) => {
    const orgCurriculumPrograms = _.get(
      getState(),
      "platform.organizationCurriculumPrograms"
    );
    const curriculumObj = _.find(
      orgCurriculumPrograms,
      curriculum => curriculum.id == curriculumId
    );
    if (curriculumObj) {
      dispatch(setCurrentCurriculumProgram(curriculumObj));
    }
  };
};

export const switchBetweenModules = ({
  metadata,
  shouldIncludeCurriculumIdInEndpoint = true,
  appendCurriculumIdInQueryParam,
}) => {
  return (dispatch, getState) => {
    let endPoint = _.get(metadata, "endPoint", "");
    const {
      routeType = ROUTE_TYPES.HOMEROUTE,
      curriculumProgramId = "",
      curriculumProgram = null,
      orgId,
      learningCourse,
    } = metadata || {};

    const isClassSearchV3Enabled = ACLStore.can("GlobalSearch:ClassSearchV3"); //Note: not  importing getIsClassSearchV3Enabled from "AppComponents/GlobalSearchBar/components/Utils"  as it  is very heavy and can cause circular dependecy in future.

    const learningCourseId = isClassSearchV3Enabled
      ? _.get(metadata, "learningCourseId", null)
      : _.get(_.first(learningCourse), "id", null);

    const curriculumPrograms = _.get(
      getState(),
      "platform.organizationCurriculumPrograms"
    );

    const programByTypeOrEndPoint = _.find(curriculumPrograms, {
      type: curriculumProgram || endPoint,
    });
    const programIdByTypeOrEndPoint = _.get(
      programByTypeOrEndPoint,
      "id",
      null
    );

    const destinationCurriculumId =
      curriculumProgramId || programIdByTypeOrEndPoint;

    if (routeType === ROUTE_TYPES.HOMEROOTROUTE) {
      dispatch(
        goToPlatformHomeRoute({ curriculumProgramId: destinationCurriculumId })
      );
      return;
    }

    if (routeType === ROUTE_TYPES.HOMEROUTE) {
      if (destinationCurriculumId) {
        dispatch(setCurriculumProgramInRedux(destinationCurriculumId));
      }
      dispatch(
        goToPlatformHomeChildRoute({
          route: endPoint,
          orgId,
          appendCurriculumIdInQueryParam,
        })
      );
      return;
    }

    if (routeType === ROUTE_TYPES.ADMINROUTE) {
      endPoint =
        curriculumProgram && shouldIncludeCurriculumIdInEndpoint
          ? `${destinationCurriculumId}/${endPoint}`
          : endPoint;

      dispatch(goToAdminChildRoute({ route: endPoint }));
      return;
    }

    if (routeType === ROUTE_TYPES.FEATUREROUTE) {
      const { curriculum } = metadata;
      if (curriculum) {
        dispatch(setCurriculumProgramInRedux(curriculum));
      }
      dispatch(
        goToPlatformHomeFeatureRoute({
          ...metadata,
          route: endPoint,
          learningCourseId,
        })
      );
      return;
    }
  };
};

export const navigateToProgressReportRoute = ({ metadata }) => {
  return (dispatch, getState) => {
    const state = getState();

    const { curriculumProgramId, courseId, setId, setType } = metadata;

    const currentCurriculumProgramId =
      getSelectedCurriculumId(state) || curriculumProgramId;

    // TODO: Remove this flag check once enabled for all
    const routePath = !ACLStore.can("GlobalSearch:ReportsSearchV2")
      ? `/platform/${currentCurriculumProgramId}/courses/${courseId}/progressreport`
      : setType === "CLASS"
      ? `/platform/${currentCurriculumProgramId}/courses/${courseId}/progressreport/${setId}`
      : `/platform/${currentCurriculumProgramId}/progress-report-sets/${setId}`;

    dispatch(
      goToRelativeRoute({
        route: routePath,
      })
    );
  };
};

export const openComment = ({
  metadata,
  navigateType,
  isParent = false,
  isUnitLibraryRoute = false,
} = {}) => {
  return (dispatch, getState) => {
    const parentType = _.toUpper(_.get(metadata, "parentType", ""));
    const academicYearId = _.get(metadata, "academicYearId", null);
    const curriculumProgramId = _.get(metadata, "curriculumProgramId", null);
    const studentId = _.get(metadata, "studentId", null);
    const orgId = _.get(metadata, "orgId", null);
    const isConsolidatedPortfolioEnabled = _.get(
      metadata,
      "isConsolidatedPortfolioEnabled",
      false
    );
    switch (parentType) {
      case "ASSESSMENT":
        dispatch(updateNavigationObject({ showAssessmentCommentBox: true }));
        dispatch(
          goToResourceDetails({
            ...metadata,
            id: metadata.parentId,
            type: "assessment",
            unitPlanId: metadata.unitPlanId,
            courseId: metadata.courseId,
            navigateType,
            isUnitLibraryRoute,
            studentId,
            academicYearId,
            orgId,
          })
        );
        break;
      case "LEARNING_ENGAGEMENT":
        dispatch(updateNavigationObject({ showLeCommentBox: true }));
        dispatch(
          goToResourceDetails({
            ...metadata,
            id: metadata.parentId,
            type: "le",
            unitPlanId: metadata.unitPlanId,
            courseId: metadata.courseId,
            navigateType,
            studentId,
            academicYearId,
            orgId,
          })
        );
        break;
      case "FIELD":
        dispatch(
          updateNavigationObject({
            unitPlanCommentBox: {
              showUnitPlanCommentBox: true,
              fieldId: metadata.parentId,
            },
            unitPlanStepRoute: {
              fieldId: metadata.parentId,
            },
          })
        );
        dispatch(
          goToUnitPlanDetail({
            ...metadata,
            unitPlanId: metadata.unitPlanId,
            courseId: metadata.courseId,
            navigateType,
            isUnitLibraryRoute,
            academicYearId,
            curriculumProgramId,
            orgId,
          })
        );
        break;

      case "POST":
        dispatch(
          updateNavigationObject({
            postDetail: {
              rightPane: "COMMENT",
              rightPaneId: metadata.item_id,
              courseId: isParent ? _.get(metadata, "course_id", null) : null,
            },
          })
        );

        if (isParent) {
          const courseId =
            _.get(metadata, "courseId") || _.get(metadata, "course_id");
          const route =
            _.get(metadata, "feedType") === "ROUTINE"
              ? `courses/${courseId}/routines`
              : getIsEnableFamilyConsolidatedPortfolio() ||
                isConsolidatedPortfolioEnabled
              ? `family-portfolio-summary`
              : `courses/${courseId}/journal`;
          dispatch(
            handleParentNotification({
              academicYearId,
              studentId: _.get(metadata, "student_id", ""),
              route,
              curriculumProgramId,
            })
          );
        } else {
          dispatch(
            goToPlatformHomeFeatureRoute({
              ...metadata,
              courseId:
                _.get(metadata, "courseId") || _.get(metadata, "course_id"),
              route:
                _.get(metadata, "feedType") === "ROUTINE"
                  ? "routines"
                  : "journal",
            })
          );
        }

        break;
      case "PROJECT":
      case "STUDENT_PROJECT_PORTFOLIO":
        {
          const {
            courseId = null,
            projectGroupSubType,
            projectGroupType,
            learningCourseIds,
          } = metadata;
          const learningCourseId = _.first(learningCourseIds);

          if (!_.isNil(courseId) && isIEAssessment({ projectGroupSubType })) {
            dispatch(
              updateNavigationObject({
                projectCommentBox: {
                  showProjectCommentBox: true,
                  fieldId: metadata.parentId,
                  commentParentEntityType: metadata.commentParentEntityType,
                },
              })
            );
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId: metadata.projectGroupId,
                route: `progress/${metadata.itemId}`,
                courseId,
                projectGroupSubType,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
                learningCourseId,
              })
            );
          } else if (!_.isEmpty(_.get(metadata, "projectGroupType", ""))) {
            switch (metadata.projectGroupType) {
              case "PERSONAL":
              case "COMMUNITY":
                {
                  dispatch(
                    updateNavigationObject({
                      projectCommentBox: {
                        showProjectCommentBox: true,
                        fieldId: metadata.parentId,
                        commentParentEntityType:
                          metadata.commentParentEntityType,
                      },
                    })
                  );
                  dispatch(
                    goToPlatformHomeProjectFeatureRoute({
                      projectGroupId: metadata.projectGroupId,
                      route: `progress/${metadata.itemId}`,
                      studentId,
                      academicYearId,
                      orgId,
                      projectGroupType,
                      curriculumProgramId,
                    })
                  );
                }
                break;
              case "SERVICE_AS_ACTION":
              case "DP_CAS":
              case "CP_SERVICE_LEARNING":
              case "COMMUNITY_ENGAGEMENT": {
                // REMOVE: this SAA condition and replace the once SAA portfolio revamp is live for all

                if (
                  !getIsSaaRevampEnabled(getState()) &&
                  metadata.projectGroupType ===
                    PROJECT_GROUP_TYPE_SERVICE_AS_ACTON
                ) {
                  dispatch(
                    updateNavigationObject({
                      projectCommentBox: {
                        showProjectCommentBox: true,
                        fieldId: metadata.parentId,
                        commentParentEntityType:
                          metadata.commentParentEntityType,
                      },
                    })
                  );
                  dispatch(
                    goToPlatformHomeProjectFeatureRoute({
                      projectGroupId: metadata.projectGroupId,
                      route: `progress/${metadata.itemId}`,
                      studentId,
                      academicYearId,
                      orgId,
                      projectGroupType,
                      curriculumProgramId,
                    })
                  );
                } else {
                  const commentParentEntityType = _.get(
                    metadata,
                    "commentParentEntityType",
                    ""
                  );
                  switch (commentParentEntityType) {
                    case "ENTITY_PLANNER_ELEMENT_NODE_MAP":
                      dispatch(
                        updateNavigationObject({
                          projectCommentBox: {
                            showProjectCommentBox: true,
                            fieldId: metadata.parentId,
                            commentParentEntityType,
                          },
                        })
                      );
                      dispatch(
                        goToPlatformHomeProjectFeatureRoute({
                          projectGroupId: metadata.projectGroupId,
                          route: `portfolios/${metadata.portfolioId}/evidences`,
                          studentId,
                          academicYearId,
                          orgId,
                          projectGroupType,
                          curriculumProgramId,
                        })
                      );
                      break;
                    default: {
                      dispatch(
                        updateNavigationObject({
                          projectCommentBox: {
                            showProjectCommentBox: true,
                            fieldId: metadata.parentId,
                            commentParentEntityType,
                          },
                        })
                      );
                      const { user_type: ut } = getUserInfo();
                      const entityType = _.get(metadata, "entityType");
                      let route = "";
                      if (entityType === "STUDENT_PROJECT_PORTFOLIO") {
                        // navigate to portfolio level
                        route = `portfolios/${metadata.portfolioId}`;
                      } else if (ut === "student") {
                        // navigate to project level through portfolio
                        route = `portfolios/${metadata.portfolioId}/studentPortfolio/${metadata.itemId}`;
                      } else {
                        // navigate to project level through experiences
                        route = `experiences/${metadata.itemId}`;
                      }

                      dispatch(
                        goToPlatformHomeProjectFeatureRoute({
                          projectGroupId: metadata.projectGroupId,
                          route,
                          studentId,
                          academicYearId,
                          orgId,
                          projectGroupType,
                          curriculumProgramId,
                        })
                      );
                      break;
                    }
                  }
                }
                break;
              }

              case "DP_EE":
              case "DP_TOK_EXHIBITION":
              case "DP_TOK_ESSAY":
              case "DP_G4_PROJECT":
              case "CP_REFLECTIVE_PROJECT":
              case "DP_COLLABORATIVE_SCIENCES_PROJECT":
                {
                  dispatch(
                    updateNavigationObject({
                      projectCommentBox: {
                        showProjectCommentBox: true,
                        fieldId: metadata.parentId,
                        commentParentEntityType:
                          metadata.commentParentEntityType,
                      },
                    })
                  );
                  dispatch(
                    goToPlatformHomeProjectFeatureRoute({
                      projectGroupId: metadata.projectGroupId,
                      route: `progress/${metadata.itemId}`,
                      studentId,
                      academicYearId,
                      orgId,
                      projectGroupType,
                      curriculumProgramId,
                    })
                  );
                }
                break;
            }
          } else {
            dispatch(
              goToPlatformHomeProjectFeatureRoute({
                projectGroupId: metadata.projectGroupId,
                route: `progress/${metadata.itemId}`,
                studentId,
                academicYearId,
                orgId,
                projectGroupType,
                curriculumProgramId,
              })
            );
          }
        }
        break;
    }
  };
};

export const doTransitionBasedOnRoles = ({ userType, curriculumProgramId }) => {
  return (dispatch, getState) => {
    const roles = ACLStore.getPermissionsArray();

    if (_.includes(roles, "StudentPortal") || userType === "parent") {
      dispatch(
        goToPlatformHomeRoute({
          curriculumProgramId,
          navigateType: "replace",
        })
      );
    } else if (_.includes(roles, "VisitorPortal")) {
      dispatch(goToRoute({ route: "platform/visitors" }));
    }
  };
};

export const goToAbsoluteAdminChildNode = ({ childId, academicYearId }) => {
  return (dispatch, getState) => {
    const parentNode = getAdminParentNodeMemoize({ childId });
    const childNode = getAdminNode(childId);
    if (childNode && parentNode) {
      const route = `/platform/administrator/${parentNode.route}/${childNode.route}`;
      dispatch(
        goToRelativeRouteHof({
          route,
          academicYearId,
        })
      );
    }
  };
};

export const goToClassRoster = ({ isOpenInNewTab = false }) => {
  return (dispatch, getState) => {
    const state = getState();
    const currentCurriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );

    const isAccountOrSchoolPortal = getIsAccountOrSchoolPortal(state);

    if (!isAccountOrSchoolPortal) {
      const childId = "STUDENTS";
      const parentNode = getAdminParentNodeMemoize({ childId });
      const childNode = getAdminNode(childId);

      if (parentNode && childNode) {
        const route = `/platform/administrator/${parentNode.route}/${childNode.route}/${currentCurriculumProgramId}`;

        if (isOpenInNewTab) {
          dispatch(openLinkInNewTabHof({ url: route }));
        } else {
          dispatch(
            goToRelativeRouteHof({
              route,
            })
          );
        }
      }
    } else {
      dispatch(
        goToRoute({
          route: `platform/school/${currentCurriculumProgramId}/students`,
          isOpenInNewTab: true,
        })
      );
    }
  };
};

export const goToAdminRoute = ({ navigateType = "push" } = {}) => {
  return (dispatch, getState) => {
    dispatch(
      goToRelativeRouteHof({
        route: `/platform/administrator`,
        type: navigateType,
      })
    );
  };
};

export const goToAdminChildRoute = ({
  route,
  isOpenInNewTab = false,
  navigateType = "push",
}) => {
  return (dispatch, getState) => {
    const routePath = `/platform/administrator/${route}`;

    if (isOpenInNewTab) {
      dispatch(openLinkInNewTabHof({ url: routePath }));
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
          type: navigateType,
        })
      );
    }
  };
};

export const goToAdminSettingsRoute = ({ navigateType = "push" } = {}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/platform/accountSettings/",
        type: navigateType,
      })
    );
  };
};

export const goToAccountAcademicPortalRoute = ({
  navigationType = "push",
} = {}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: `/platform/accountSettings/academicAccountPortal`,
        type: navigationType,
      })
    );
  };
};

export const goToAdminHomeRoute = ({ navigateType = "push" } = {}) => {
  return (dispatch, getState) => {
    dispatch(
      goToRelativeRouteHof({
        route: `/platform/admin-home`,
        type: navigateType,
      })
    );
  };
};

export const goToToolRoute = ({ navigateType = "push" } = {}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/platform/regions",
        type: navigateType,
      })
    );
  };
};

export const goToPlatformAccessManagerRoute = ({
  navigateType = "push",
} = {}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/platform/pam",
        type: navigateType,
      })
    );
  };
};

export const navigateToPlatformAccessManager = () => {
  return dispatch => {
    dispatch(goToPlatformAccessManagerRoute());
  };
};

export const navigateToMyFamilyProfile = () => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/platform/family-profile/my-profile",
      })
    );
  };
};

export const navigateToToolsPortal = () => {
  return dispatch => {
    dispatch(goToToolRoute());
  };
};

export const goToToolRouteV2 = ({ navigateType = "push" } = {}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/platform/tools/common",
        type: navigateType,
      })
    );
  };
};

export const navigateToToolsPortalV2 = () => {
  return dispatch => {
    dispatch(goToToolRouteV2());
  };
};

export const goToPlatformHomeRoute = ({
  navigateType = "push",
  curriculumProgramId,
} = {}) => {
  return (dispatch, getState) => {
    const isCombinedCurriculumHomePage = getIsCombineCurriculumHomePageEnabled();

    if (isCombinedCurriculumHomePage) {
      dispatch(
        goToRelativeRouteHof({
          route: "/platform/my-home",
        })
      );
      return;
    }

    const state = getState();
    const fallbackCurriculumProgramType = getCurrentCurriculumProgramType(
      state
    );
    const organizationCurriculumPrograms = getOrganizationCurriculumPrograms(
      state
    );

    const fallbackCurriculumProgram = _.find(organizationCurriculumPrograms, {
      type: fallbackCurriculumProgramType,
    });
    const curriculumProgram = _.find(organizationCurriculumPrograms, {
      id: curriculumProgramId,
    });

    const finalCurriculumProgram = _.pick(
      curriculumProgram ?? fallbackCurriculumProgram,
      ["id", "type", "label"]
    );
    setJsonItem({
      key: "currentCurriculumProgram",
      value: finalCurriculumProgram,
    });

    dispatch(
      goToRelativeRouteHof({
        route: `/platform/${
          curriculumProgramId ?? fallbackCurriculumProgram?.id
        }`,
        type: navigateType,
      })
    );
  };
};

const getCombinedCurriculumHomeChildRoute = ({
  route,
  curriculumProgramId,
  appendCurriculumIdInQueryParam,
}) => {
  const routeUrl = new URL(route, window.location.origin);

  const shouldAppendCurriculumId =
    appendCurriculumIdInQueryParam && curriculumProgramId;

  const finalSearchQuery = shouldAppendCurriculumId
    ? `?${getQueryUpdatedQueryString({
        url: routeUrl.search,
        params: { initialCurriculumProgramId: curriculumProgramId },
      })}`
    : routeUrl.search;

  return `/platform/my-home${routeUrl.pathname}${finalSearchQuery}${routeUrl.hash}`;
};

export const goToPlatformHomeChildRoute = ({
  route,
  isOpenInNewTab,
  curriculumProgramId,
  navigateType = "push",
  studentId,
  academicYearId,
  orgId,
  routeState = {},
  appendCurriculumIdInQueryParam = false,
  isCombinedCurriculumHome = false,
}) => {
  return (dispatch, getState) => {
    const { currentCurriculumProgram } = getState().platform;
    const curriculumIdToRedirect =
      curriculumProgramId || currentCurriculumProgram.id;

    const isCombinedCurriculum =
      getIsCombineCurriculumHomePageEnabled() || isCombinedCurriculumHome;

    const routePath = isCombinedCurriculum
      ? getCombinedCurriculumHomeChildRoute({
          route,
          curriculumProgramId: curriculumIdToRedirect,
          appendCurriculumIdInQueryParam,
        })
      : `/platform/${curriculumIdToRedirect}/${route}`;

    if (isOpenInNewTab) {
      dispatch(
        openLinkInNewTabHof({ url: routePath, studentId, academicYearId })
      );
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
          type: navigateType,
          studentId,
          academicYearId,
          orgId,
          state: routeState,
        })
      );
    }
  };
};

export const goToAssessmentInSchoolLibrary = ({
  id,
  isOpenInNewTab = false,
  curriculumProgramId: _curriculumProgramId,
  mode = "view",
}) => {
  return async (dispatch, getState) => {
    const curriculumProgramId =
      _curriculumProgramId ?? getSelectedCurriculumId(getState());

    dispatch(
      goToPlatformHomeChildRoute({
        route: `school-library/tasks/assessment/${id}/${mode}`,
        curriculumProgramId,
        isOpenInNewTab,
      })
    );
  };
};

export const goToMessagingLinkRoute = ({ chatId }) => {
  return dispatch => {
    const routePath = `/platform/links/messaging-link?chatId=${chatId}`;
    dispatch(
      goToRelativeRouteHof({
        route: routePath,
      })
    );
  };
};

export const goToStudentProfileRoute = ({
  studentId,
  navigateType = "push",
  isOpenInNewTab = false,
  currentCurriculumProgramId,
  activeTab,
  academicYearId,
  orgId,
}) => {
  return dispatch => {
    if (!currentCurriculumProgramId) {
      return;
    }

    const route = activeTab
      ? `student-profile/${studentId}/${activeTab}`
      : `student-profile/${studentId}`;

    /**
     * Store navigation context for Sentral portal integration
     * This enables back navigation when users return from Sentral's student profile
     * to the original location they came from
     */
    if (
      isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.STUDENT_PROFILE
      )
    ) {
      const isCCHEnabled = getIsCombineCurriculumHomePageEnabled();
      const studentProfileUrl = isCCHEnabled
        ? getCombinedCurriculumHomeChildRoute({ route })
        : `/platform/${currentCurriculumProgramId}/${route}`;
      storeStudentNavigationForSentral({
        currentUrl: window.location.pathname,
        studentProfileUrl,
      });
    }

    dispatch(
      goToPlatformHomeChildRoute({
        route,
        curriculumProgramId: currentCurriculumProgramId,
        isOpenInNewTab,
        navigateType,
        studentId,
        academicYearId,
        orgId,
      })
    );
  };
};

export const goToFamilyProfileRoute = ({
  familyId,
  navigateType = "push",
  isOpenInNewTab = false,
  curriculumProgramId,
}) => {
  return dispatch => {
    const baseRoute = `platform`;
    const familyProfileRoute = `family-profile/${familyId}`;

    const curriculumRoute = `/${baseRoute}/${curriculumProgramId}/${familyProfileRoute}`;
    const nonCurriculumRoute = `/${baseRoute}/${familyProfileRoute}`;

    const finalRoute = curriculumProgramId
      ? curriculumRoute
      : nonCurriculumRoute;

    if (isOpenInNewTab) {
      dispatch(openLinkInNewTabHof({ url: finalRoute }));
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: finalRoute,
          type: navigateType,
        })
      );
    }
  };
};

export const goToLearningCourseChildRoute = ({
  learningCourseId: _learningCourseId,
  route = "",
  navigateType = "push",
  curriculumProgramId: _curriculumProgramId,
  isOpenInNewTab = false,
  classId,
  routeState = {},
}) => {
  return (dispatch, getState) => {
    const state = getState();

    const isCombinedCurriculum = getIsCombineCurriculumHomePageEnabled();

    let curriculumProgramId = _curriculumProgramId;
    if (!_curriculumProgramId) {
      curriculumProgramId = getSelectedCurriculumId(state);
    }

    let learningCourseId = _learningCourseId;
    if (!learningCourseId) {
      learningCourseId = getSelectedLearningCourseId(state);
    }

    const learningCourseBaseRoute =
      learningCourseId && `learning-course/${learningCourseId}`;

    const classRoute = classId && `class/${classId}`;

    // NOTE : Handling separately for class-settings as it has a separate route structure in learning courses

    let routeToNavigate =
      route === "class-settings" && classId
        ? _.join(
            ["learning-course", learningCourseId, "class-settings", classId],
            "/"
          )
        : _.join(_.compact([learningCourseBaseRoute, classRoute, route]), "/");

    if (isToddleLibraryRoute()) {
      routeToNavigate = `${learningCourseBaseRoute}/${route}`;
    }

    if (
      (!curriculumProgramId && !isCombinedCurriculum) ||
      (!learningCourseId && !classId)
    ) {
      dispatch(goToRelativeRoute({ route: "/", state: routeState }));
      return;
    }
    dispatch(
      goToPlatformHomeChildRoute({
        route: routeToNavigate,
        navigateType,
        curriculumProgramId,
        isOpenInNewTab,
        routeState,
      })
    );
  };
};

export const goToPlatformHomeFeatureRoute = ({
  courseId,
  route,
  navigateType = "push",
  isOpenInNewTab,
  course_id,
  curriculumProgramId,
  academicYearId,
  studentId,
  orgId,
  learningCourseId = null,
}) => {
  return (dispatch, getState) => {
    const state = getState();

    const currentCurriculumProgram = state.platform.currentCurriculumProgram;

    let currentCurriculumProgramId =
      currentCurriculumProgram.id || curriculumProgramId;

    if (isToddleLibraryRoute() && getIsLearningCoursesEnabled()) {
      currentCurriculumProgramId =
        curriculumProgramId || currentCurriculumProgramId;
    }

    const isLearningCoursesEnabled =
      !!learningCourseId ||
      getIsLearningCoursesEnabled({
        curriculumProgramId: currentCurriculumProgramId,
      });

    const userInfo = getUserInfo();
    const userType = userInfo.user_type;
    const isUserTeacher = isUserTypeStaff({ userType });

    const courseIdToRedirect =
      courseId || course_id
        ? courseId || course_id
        : state.teacher
        ? state.teacher.selected_class.selected_course
        : "";

    if (isLearningCoursesEnabled && isUserTeacher) {
      dispatch(
        goToLearningCourseChildRoute({
          learningCourseId,
          curriculumProgramId: currentCurriculumProgramId,
          type: navigateType,
          isOpenInNewTab,
          route,
          classId: courseId || course_id,
        })
      );
      return;
    }

    if (!courseIdToRedirect) {
      return;
    }

    const isCombinedCurriculum = getIsCombineCurriculumHomePageEnabled();
    const routePath = isCombinedCurriculum
      ? `/platform/my-home/courses/${courseIdToRedirect}/${route}`
      : `/platform/${currentCurriculumProgramId}/courses/${courseIdToRedirect}/${route}`;
    if (isOpenInNewTab) {
      dispatch(
        openLinkInNewTabHof({ url: routePath, academicYearId, studentId })
      );
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
          type: navigateType,
          academicYearId,
          studentId,
          orgId,
        })
      );
    }
  };
};

export const goToPlatformHomeProjectFeatureRoute = ({
  projectGroupId,
  route,
  navigateType = "push",
  isOpenInNewTab,
  courseId = null,
  projectGroupSubType = "",
  studentId,
  academicYearId,
  orgId,
  projectGroupType: projectGroupTypeParams = "",
  curriculumProgramId: curriculumProgramIdParams = "",
  learningCourseId = null,
}) => {
  return async (dispatch, getState) => {
    const {
      curriculumProgramId,
      curriculumProgramType = "",
    } = curriculumProgramIdParams
      ? { curriculumProgramId: curriculumProgramIdParams }
      : dispatch(
          getCurriculumTypeFromProjectGroupId({
            projectGroupId,
          })
        );

    const projectGroupType =
      projectGroupTypeParams ||
      getProjectGroupTypeFromId({
        state: getState(),
        projectGroupId,
      });

    const isProjectGroupValid =
      getIsCoreOrSubjectGroupType({
        projectGroupType,
      }) || isIEAssessment({ projectGroupSubType });

    if (!isProjectGroupValid) {
      dispatch(goToPageNotFound());
      return;
    }
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled({
      curriculumProgramId,
    });

    /*******************************************************************************************************
     * For visitor, curriculum context is not maintained in portal
     * So we set curriculum context from project group
     ********************************************************************************************************/

    const userInfo = getUserInfo();
    const { role: userRole, user_type: userType } = userInfo;
    const isUserStaff = isUserTypeStaff({ userType });
    const isUserRoleVisitor = _.isEqual(userRole, ROLE_VISITOR);

    const useNewCourseRoute =
      isLearningCoursesEnabled && learningCourseId && isUserStaff;

    if (isUserRoleVisitor) {
      dispatch(
        setCurrentCurriculumProgram({
          id: curriculumProgramId,
          type: curriculumProgramType,
        })
      );
    }

    let routePath = "";

    if (!_.isNil(courseId) && isIEAssessment({ projectGroupSubType })) {
      if (useNewCourseRoute) {
        routePath = `/platform/${curriculumProgramId}/learning-course/${learningCourseId}/class/${courseId}/projects/${projectGroupId}/${route}`;
      } else {
        routePath = `/platform/${curriculumProgramId}/courses/${courseId}/projects/${projectGroupId}/${route}`;
      }
    } else {
      routePath = isUserRoleVisitor
        ? `/platform/visitors/project-group-types/${projectGroupType}/projects/${projectGroupId}/${route}`
        : `/platform/${curriculumProgramId}/project-group-types/${projectGroupType}/projects/${projectGroupId}/${route}`;
    }

    if (isOpenInNewTab) {
      dispatch(
        openLinkInNewTabHof({ url: routePath, studentId, academicYearId })
      );
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
          type: navigateType,
          studentId,
          academicYearId,
          orgId,
        })
      );
    }
  };
};

/**
 * Utility function to go inside project by project group type
 */
export const goToProjectFeatureRouteByProjectGroupType = ({
  projectGroupType,
  navigateType = "push",
}) => {
  return async (dispatch, getState) => {
    const curriculumProgramId = _.get(
      getState(),
      "platform.currentCurriculumProgram.id",
      null
    );
    const routePath = `/platform/${curriculumProgramId}/project-group-types/${projectGroupType}`;

    dispatch(
      goToRelativeRouteHof({
        route: routePath,
        navigateType,
      })
    );
  };
};

export const goToRoute = ({ route, isOpenInNewTab }) => {
  return (dispatch, getState) => {
    const routePath = `/${route}`;

    if (isOpenInNewTab) {
      dispatch(openLinkInNewTabHof({ url: routePath }));
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
        })
      );
    }
  };
};

export const goToBack = () => {
  return (dispatch, getState) => {
    goBack();
  };
};

export const goToIndex = index => {
  return (dispatch, getState) => {
    go(index);
  };
};

export const goToLibraryEntity = ({
  entityType,
  entityId,
  isOpenInNewTab = true,
  params,
}) => {
  return (dispatch, getState) => {
    let routePath = "";
    let url = "";

    switch (entityType) {
      case "UnitPlan":
        url = checkIsUnitPlanViewRevampEnabledInLibrary()
          ? `/toddle-library/units/${entityId}`
          : `/toddle-library/units/${entityId}/view`;
        break;
      case "LEARNING_ENGAGEMENT":
        url = `/toddle-library/assessment/${entityId}/view`;
        break;
      case "LECollection":
        url = `/toddle-library/collection/${entityId}`;
        break;
      case "WORKSHEET":
      case "E_ASSESSMENT":
      case "WORKSHEET_ASSESSMENT":
        url = `/toddle-library/worksheet/${entityId}`;
        break;
    }

    const queryString = getQueryUpdatedQueryString({ url, params });
    routePath = `${url}${queryString ? `?${queryString}` : ``}`;

    if (isOpenInNewTab) {
      dispatch(openLinkInNewTabHof({ url: routePath }));
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
        })
      );
    }
  };
};

export const goToSnpHomeChildRoute = ({
  route,
  isOpenInNewTab,
  navigateType = "push",
}) => {
  return (dispatch, getState) => {
    const routePath = `/platform/visitors/${route}`;

    if (isOpenInNewTab) {
      dispatch(openLinkInNewTabHof({ url: routePath }));
    } else {
      dispatch(
        goToRelativeRouteHof({
          route: routePath,
          type: navigateType,
        })
      );
    }
  };
};

export const goToPageNotFound = () => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/page-not-found",
        type: "replace",
      })
    );
  };
};

export const goToUserBlockedPage = (data = {}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/user-blocked",
        type: "replace",
        state: { ...data },
      })
    );
  };
};

export const goToMigrationInProgress = (data = {}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/migration-in-progress",
        type: "replace",
        state: { ...data },
      })
    );
  };
};

export const goToRootPath = () => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: "/",
        type: "replace",
      })
    );
  };
};

// used to navigate to organization workspace specific login page (School login page)
export const navigateToOrgWorkspaceLoginPage = data => {
  return dispatch => {
    const { schoolcode, userType, skipMobileRedirect = false } = data;
    const params = {};
    let paramsToBeRemoved = [];

    switch (userType) {
      case "staff":
        params["type"] = "teacherLogin";
        break;
      case "student":
        params["type"] = "studentLogin";
        break;
      case "parent":
        params["type"] = "parentLogin";
        break;
      default:
        paramsToBeRemoved = ["type", "usertype"];
        break;
    }
    const queryString = getQueryUpdatedQueryString({
      url: _.get(window, "location.search", ""),
      params,
      paramsToBeRemoved,
    });

    if (skipMobileRedirect) {
      sessionStorage.setItem("skipMobileRedirect", "true");
    }
    dispatch(
      goToRoute({
        route: `account/${schoolcode}?${queryString}`,
      })
    );
    if (!_.isEmpty(params.type)) {
      dispatch(
        updateCurrentScreen({
          type: params.type,
          navigateType: "replace",
        })
      );
    }
  };
};

export const getCurriculumTypeFromProjectGroupId = ({ projectGroupId }) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const projectGroupType = getProjectGroupTypeFromId({
      state: getState(),
      projectGroupId,
    });

    const projectGroups = userInfo.projectGroups;

    const selectedCurriculumProgram = _.find(projectGroups, {
      type: projectGroupType,
    })?.curriculumProgram;

    let curriculumProgramId = selectedCurriculumProgram?.id;

    const curriculumProgramType = _.get(
      selectedCurriculumProgram,
      "type",
      CURRICULUM_TYPE_MYP
    );

    if (!curriculumProgramId) {
      const organizationCurriculumPrograms = getState().platform
        .organizationCurriculumPrograms;

      curriculumProgramId = _.find(organizationCurriculumPrograms, {
        type: curriculumProgramType,
      })?.id;
    }

    return {
      curriculumProgramId,
      curriculumProgramType,
    };
  };
};

export const navigateToMBSponteFeeWidget = ({
  userId,
  curriculumProgramId,
}) => {
  return dispatch => {
    dispatch(
      goToRelativeRouteHof({
        route: `/platform/${curriculumProgramId}/mb-fee-portal/${userId}`,
      })
    );
  };
};

export const redirectToCombinedCurriculumRoute = () => {
  return dispatch => {
    const { pathname, search, hash } = window.location;

    const newPathname = pathname.replace(
      /^\/platform\/\d+/,
      "/platform/my-home"
    );

    if (pathname === newPathname) return;

    const newRoute = `${newPathname}${search}${hash}`;

    dispatch(
      goToRelativeRouteHof({
        route: newRoute,
        type: "replace",
      })
    );
  };
};

// Auto-generated exports
export { setCurriculumProgramInRedux };

const PORTAL_REPLACE_PATH_MAP = {
  [TEACHER_PROFILE_NAV_CONTEXT.ADMIN]: "administrator",
  [TEACHER_PROFILE_NAV_CONTEXT.SCHOOL]: "school",
  [TEACHER_PROFILE_NAV_CONTEXT.ACCOUNT_SETTINGS]: "accountSettings",
  [TEACHER_PROFILE_NAV_CONTEXT.TODDLE_LIBRARY]: "toddle-library",
};

export const navigateToTeacherProfile = ({
  id,
  context,
  navigateType = "push",
  curriculumProgramId,
  isOpenInNewTab,
  routeState,
  studentId,
  academicYearId,
  orgId,
  appendCurriculumIdInQueryParam,
}) => dispatch => {
  const isCCHEnabled = getIsCombineCurriculumHomePageEnabled();
  const replacePath = PORTAL_REPLACE_PATH_MAP[context];

  if (replacePath && !isCCHEnabled) {
    // TODDLE_LIBRARY: TeacherProfile is not registered under toddle-library route,
    // so prefix with "platform/" to cross-portal navigate correctly.
    const route =
      context === TEACHER_PROFILE_NAV_CONTEXT.TODDLE_LIBRARY
        ? `platform/teacher-profile/${id}`
        : `teacher-profile/${id}`;

    dispatch(
      goToRelativeRoute({
        route,
        replacePath,
        type: navigateType,
      })
    );
    return;
  }

  // CCH ON or CURRICULUM context — goToPlatformHomeChildRoute handles CCH internally:
  // CCH ON  → /platform/my-home/teacher-profile/:id
  // CCH OFF → /platform/:curriculumProgramId/teacher-profile/:id
  dispatch(
    goToPlatformHomeChildRoute({
      route: `teacher-profile/${id}`,
      curriculumProgramId,
      navigateType,
      isOpenInNewTab,
      routeState,
      studentId,
      academicYearId,
      orgId,
      appendCurriculumIdInQueryParam,
    })
  );
};
